import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import _ from 'lodash';
import fs from 'fs';
import mkdirp from 'mkdirp';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import emailjs from 'emailjs-com'
//utils
import queries from '../../utils/queries'
import actCartera from '../../functions/actcartera';

import HomeAdmin1 from './homeadmin1';
import HomeAdmin2 from './homeadmin2';

// import AdminMeta1 from './admin/adminmeta1';
// import AdminMeta2 from './admin/adminmeta2';
// import AddMeta1 from './admin/addmeta1';
// import AddMeta2 from './admin/addmeta2';
// import VerMeta1 from './admin/vermeta1';
// import VerMeta2 from './admin/vermeta2';

import AdminPolitica1 from './admin/adminpolitica1';
import AdminPolitica2 from './admin/adminpolitica2';
import AddPolitica1 from './admin/addpolitica1';
import AddPolitica2 from './admin/addpolitica2';
import VerPolitica1 from './admin/verpolitica1';
import VerPolitica2 from './admin/verpolitica2';


import AdminCotizacion1 from './admin/admincotizacion1';
import AdminCotizacion2 from './admin/admincotizacion2';
import AddCotizacion1 from './admin/addcotizacion1';
import AddCotizacion2 from './admin/addcotizacion2';
import VerCotizacion1 from './admin/vercotizacion1';
import VerCotizacion2 from './admin/vercotizacion2';
import AddItemCoti2 from './admin/additemcoti2';
import AdminEnvCoti1 from './admin/adminenvcoti1';
import AdminEnvCoti2 from './admin/adminenvcoti2';
import AsocDocCoti1 from './admin/asocdoccoti1';
import AsocDocCoti2 from './admin/asocdoccoti2';
import AdminOrdenCompra1 from './admin/adminordencompra1';
import AdminOrdenCompra2 from './admin/adminordencompra2';
import AddOrdenCompra1 from './admin/addordencompra1';
import AddOrdenCompra2 from './admin/addordencompra2';
import VerOrdenCompra1 from './admin/verordencompra1';
import VerOrdenCompra2 from './admin/verordencompra2';
import AddItemOC2 from './admin/additemoc2';
import AdminOrdenCompraFin1 from './admin/adminordencomprafin1';
import AdminOrdenCompraFin2 from './admin/adminordencomprafin2';
import VerOrdenCompraFin1 from './admin/verordencomprafin1';
import VerOrdenCompraFin2 from './admin/verordencomprafin2';
import AddItemEnc2 from './admin/additemenc2';
import AdminEncuesta1 from './admin/adminencuesta1';
import AdminEncuesta2 from './admin/adminencuesta2';
import VerEncuesta1 from './admin/verencuesta1';
import VerEncuesta2 from './admin/verencuesta2';
import AdminFacturacion1 from './admin/adminfacturacion1';
import AdminFacturacion2 from './admin/adminfacturacion2';
import AdminFacturacionLog1 from './admin/adminfacturacionlog1';
import AdminFacturacionLog2 from './admin/adminfacturacionlog2';
import VerFacturacion1 from './admin/verfacturacion1';
import VerFacturacion2 from './admin/verfacturacion2';
import AdminCadena1 from './admin/admincadena1';
import AdminCadena2 from './admin/admincadena2';
import AdminRecaudoLog1 from './admin/adminrecaudolog1';
import AdminRecaudoLog2 from './admin/adminrecaudolog2';

import AdminCotizacionPro1 from './admin/admincotizacionpro1';
import AdminCotizacionPro2 from './admin/admincotizacionpro2';
import AddCotizacionPro1 from './admin/addcotizacionpro1';
import AddCotizacionPro2 from './admin/addcotizacionpro2';
import VerCotizacionPro1 from './admin/vercotizacionpro1';
import VerCotizacionPro2 from './admin/vercotizacionpro2';
import AddItemCotiPro2 from './admin/additemcotipro2';
import AdminCotizacionProve1 from './admin/admincotizacionprove1';
import AdminCotizacionProve2 from './admin/admincotizacionprove2';
import AddCotizacionProve1 from './admin/addcotizacionprove1';
import AddCotizacionProve2 from './admin/addcotizacionprove2';
import VerCotizacionProve1 from './admin/vercotizacionprove1';
import VerCotizacionProve2 from './admin/vercotizacionprove2';
import AdminCotizacionSelecc1 from './admin/admincotizacionselecc1';
import AdminCotizacionSelecc2 from './admin/admincotizacionselecc2';
import AdminOrdenCompraPro1 from './admin/adminordencomprapro1';
import AdminOrdenCompraPro2 from './admin/adminordencomprapro2';
import AdminRegPago1 from './admin/adminregpago1';
import AdminRegPago2 from './admin/adminregpago2';
import VerRegPago1 from './admin/verregpago1';
import VerRegPago2 from './admin/verregpago2';
import AdminPagosCli1 from './admin/adminpagoscli1';
import AdminPagosCli2 from './admin/adminpagoscli2';
import VerPagosCli1 from './admin/verpagoscli1';
import VerPagosCli2 from './admin/verpagoscli2';
import AdminInd1 from './admin/adminind1';
import AdminInd2 from './admin/adminind2';
import AdminPagosCli21 from './admin/adminpagoscli21';
import AdminPagosCli22 from './admin/adminpagoscli22';
import AdminTraslado1 from './admin/admintraslado1';
import AdminTraslado2 from './admin/admintraslado2';
import AddTraslado1 from './admin/addtraslado1';
import AddTraslado2 from './admin/addtraslado2';
import VerTraslado1 from './admin/vertraslado1';
import VerTraslado2 from './admin/vertraslado2';
import AddItemTras2 from './admin/additemtras2';
import AdminTrasladoFin1 from './admin/admintrasladofin1';
import AdminTrasladoFin2 from './admin/admintrasladofin2';
import VerTrasladoFin1 from './admin/vertrasladofin1';
import VerTrasladoFin2 from './admin/vertrasladofin2';
import AdminPrecios1 from './admin/adminprecios1';
import AdminPrecios2 from './admin/adminprecios2';

var moment = require('moment');

class HomeAdmin extends React.Component{
  state={
    showAdmin: true,
    showPolitica: false, addPolitica: false, verPolitica: false,
    showCotizacion: false, addCotizacion: false, verCotizacion: false, 
    showTraslado: false, addTraslado: false, verTraslado: false, addItemTras: false, 
    showTrasladoFin: false, verTrasladoFin: false, adminPrecios: false,
    addItemCoti: false, envCotizacion: false, showAsDocCoti: false, 
    showOrdenCompra: false, addOrdenCompra: false, verOrdenCompra: false, addItemOC: false, 
    showOrdenCompraFin: false, verOrdenCompraFin: false, addItemEnc: false, 
    showEncuesta: false, verEncuesta: false, showFacturacion: false, showFacturacionLog: false, verFacturacion: false, 
    showCadena: false, argsBuscar: {}, argsBuscEmp: {}, argsBuscCad: {}, showRecaudoLog: false, 
    showCotizacionPro: false, addCotizacionPro: false, verCotizacionPro: false,
    showCotizacionProve: false, addCotizacionProve: false, verCotizacionProve: false,
    addItemCotiPro: false, showCotizacionSelecc: false, showOrdenCompraPro: false, 
    showRegPago: false, verRegPago: false, showPagosCli: false, showPagosCli2: false, verPagosCli: false, showInd: false,
    permiteUpdate: false, permiteDelete: false, argsBuscCoti: {},
    argsAdd: {}, errorAdd: [], lista4: [], addItem: "N", addItemT: "N", tipoC: "", lista5: [], lista6: [], lista55: [], lista7: [], 
    idLista: {}, productoI: '', preguntaE: '', valoracionE: 0,
    argsQuery: `{$match: {tipoCoti: 'Cliente'}}, 
    {"$unwind": "$itemsCoti"},
    {$project: {_id: {$concat: ['$numCoti', '$itemsCoti.descrProducto']}, numCoti: 1,
        descrProducto: '$itemsCoti.descrProducto',  descrCorta: '$itemsCoti.descrCorta',
        numProductoCoti: '$itemsCoti.numProductoCoti',
        cantidadCoti: '$itemsCoti.cantidadCoti', 
        valorUniCoti: '$itemsCoti.valorUniCoti', 
        porcDcto: '$itemsCoti.porcDcto',
        porcIncremento: '$itemsCoti.porcIncremento',
        porcIVA: '$itemsCoti.porcIVA',
        descrUnidad: '$itemsCoti.descrUnidad',
        moneda: '$itemsCoti.moneda'}},
    {$sort: {descrProducto: 1}}`,
    argsQuery1: `{$match: {tipoCoti: 'Cliente'}}, 
    {"$unwind": "$itemsCoti"},
    {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, 
        numCoti: 1, consecDespacho: 1, consecAvance: 1, descrEmpresa: 1, nombreUsuarioOC: 1, 
        mail: 1, ciudad: 1, contacto: 1, celular: 1, ordenCompraCliente: 1, nombreUsuario: 1, 
        nombreContacto: 1, ciudadContacto: 1, cargoContacto: 1, mailContacto: 1, telContacto: 1, 
        tipoProducto: '$itemsCoti.tipoProducto',
        descrProducto: '$itemsCoti.descrProducto',  descrCorta: '$itemsCoti.descrCorta',
        numProductoCoti: '$itemsCoti.numProductoCoti',
        cantidadAprob: '$itemsCoti.cantidadAprob', 
        valorUniAprob: '$itemsCoti.valorUniAprob', 
        porcDcto: '$itemsCoti.porcDcto',
        porcIncremento: '$itemsCoti.porcIncremento',
        porcIVA: '$itemsCoti.porcIVA',
        moneda: '$itemsCoti.moneda',
        descrUnidad: '$itemsCoti.descrUnidad',
        cantidadDespacho: '$itemsCoti.cantidadDespacho',
        cantidadFact: '$itemsCoti.cantidadFact',
        cantidadCompra: '$itemsCoti.cantidadCompra', cantidadCompraEjec: '$itemsCoti.cantidadCompraEjec'}},
    {$project: {_id: {$concat: ['$numOrdenCompra', '$descrProducto']}, 
        numCoti: 1, consecDespacho: 1, consecAvance: 1, descrEmpresa: 1, nombreUsuarioOC: 1, 
        mail: 1, ciudad: 1, contacto: 1, celular: 1, ordenCompraCliente: 1, nombreUsuario: 1, 
        nombreContacto: 1, ciudadContacto: 1, cargoContacto: 1, mailContacto: 1, telContacto: 1,
        numOrdenCompra: 1, tipoProducto: 1, descrProducto: 1, descrCorta: 1, cantidadAprob: 1, valorUniAprob: 1, porcIVA: 1, numProductoCoti: 1,
        moneda: 1, porcDcto: 1, porcIncremento: 1, descrUnidad: 1, cantidadDespacho: 1, cantidadFact: 1, cantidadCompra: 1, cantidadCompraEjec: 1}},
    {$sort: {descrProducto: 1}}`,
    argsQuery2: `{$match: {tipoCoti: 'Cliente'}}, 
    {"$unwind": "$itemsEncuesta"},
    {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, 
        pregunta: '$itemsEncuesta.pregunta', 
        valoracion: '$itemsEncuesta.valoracion'}}, 
      {$project: {_id: {$concat: ['$numOrdenCompra', '$pregunta']}, 
        numOrdenCompra: 1, pregunta: 1, valoracion: 1}},
    {$sort: {pregunta: 1}}`,
    argsQuery3: `{$match: {tipoCoti: 'Cliente'}}, 
    {"$unwind": "$itemsCoti"},
    {$project: {_id: {$concat: ['$numCoti', '$itemsCoti.descrProducto']}, numCoti: 1,
        descrProducto: '$itemsCoti.descrProducto',  descrCorta: '$itemsCoti.descrCorta', 
        numProductoCoti: '$itemsCoti.numProductoCoti',
        cantidadCoti: '$itemsCoti.cantidadCoti', 
        cantidadAprob: '$itemsCoti.cantidadAprob',
        cantidadRecibida: '$itemsCoti.cantidadRecibida',
        valorUniCoti: '$itemsCoti.valorUniCoti', 
        porcDcto: '$itemsCoti.porcDcto',
        porcIncremento: '$itemsCoti.porcIncremento',
        porcIVA: '$itemsCoti.porcIVA',
        descrUnidad: '$itemsCoti.descrUnidad',
        moneda: '$itemsCoti.moneda'}},
        {$match: {cantidadAprob: {$gt: 0}}}, {$sort: {descrProducto: 1}}`,
    argsQuery4: `{$match: {tipoCoti: 'Cliente'}}, 
    {"$unwind": "$itemsCoti"},
      {$project: {_id: {$concat: ['$numCoti', '$itemsCoti.descrProducto']}, numCoti: 1,
        descrProducto: '$itemsCoti.descrProducto',  descrCorta: '$itemsCoti.descrCorta', 
        numProductoCoti: '$itemsCoti.numProductoCoti', 
        cantidadRecibida: '$itemsCoti.cantidadRecibida',
        valorUniCoti: '$itemsCoti.valorUniCoti', 
        porcDcto: '$itemsCoti.porcDcto',
        porcIncremento: '$itemsCoti.porcIncremento',
        porcIVA: '$itemsCoti.porcIVA',
        descrUnidad: '$itemsCoti.descrUnidad',
        moneda: '$itemsCoti.moneda'}},
        {$match: {cantidadRecibida: {$gt: 0}}}, {$sort: {descrProducto: 1}}`,
    argsQuery5: `{$match: {tipoCoti: 'Cliente'}},
      {"$unwind": "$itemsFactura"},
      {$project: {_id: 1, numOrdenCompra: 1, valorFact: '$itemsFactura.valorFact', 
      valorPagado: '$itemsFactura.valorPagado'
      }},
      {$group: {_id: {_id: '$_id', numOrdenCompra: '$numOrdenCompra'},
        valorTotalFact: {$sum: {$toDouble: '$valorFact'}}, valorTotalPago: {$sum: {$toDouble: '$valorPagado'}}
      }},
      {$project: {_id: '$_id._id', numOrdenCompra: '$_id.numOrdenCompra', 
      valorFact: {$toDouble: '$valorTotalFact'}, valorPagado: {$toDouble: '$valorTotalPago'}
      }}`,
    argsQuery6: `{$match: {tipoCoti: 'Cliente'}},
    {$project: {_id: 1, 
      itemsDespacho: {
        $let: {
          vars: {regItem: { $cond: { if: { $isArray: "$itemsDespacho" },
                                        then: { $size: "$itemsDespacho" },
                                        else: 0} }
          },
          in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                              then: "$itemsDespacho",
                              else: [{cantidad: 0, valorDes: 0, porcIVADes: 0, porcDctoDes: 0, porcIncrementoDes: 0}] 
          }}
      }},      
      numOrdenCompra: 1, estadoOC: 1}},
    {"$unwind": "$itemsDespacho"},
    {$project: {_id: 1, numOrdenCompra: 1, estadoOC: 1,
      cantidad: '$itemsDespacho.cantidad', porcIncrementoDes: '$itemsDespacho.porcIncrementoDes', despFact: '$itemsDespacho.despFact',
      valorDes: '$itemsDespacho.valorDes', porcIVADes: '$itemsDespacho.porcIVADes', porcDctoDes: '$itemsDespacho.porcDctoDes'}},   
    {$match: {despFact: 'F'}},
    {$project: {_id: 1, numOrdenCompra: 1, 
    valorItemIVA: {
            $let: {
              vars: {cantidad: {$toInt: '$cantidad'}, valorDes: '$valorDes', porcIVADes: {$toInt: '$porcIVADes'}, porcDctoDes: {$toInt: '$porcDctoDes'}, porcIncrementoDes: {$toInt: '$porcIncrementoDes'}},
              in: { $multiply: [{ $multiply: [ "$$cantidad", {$multiply: [{$divide: ["$$valorDes", {$divide: [{$add: ["$$porcIncrementoDes", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDctoDes", -100]}, -100 ]} ]} ]}, {$add: [1, {$divide: [ "$$porcIVADes", 100 ]} ]}]}
            }
          }
    }},
    {$group: {_id: {_id: '$_id', numOrdenCompra: '$numOrdenCompra', estadoOC: '$estadoOC'},
      valorTotalIVA: {$sum: {$toDouble: '$valorItemIVA'}}
    }},
    {$project: {_id: '$_id._id', numOrdenCompra: "$_id.numOrdenCompra", estadoOC: '$_id.estadoOC', 
      cantidad: {$toDouble: '$valorTotalIVA'}
    }}`,
    argsQuery7: `{$match: {tipoCoti: 'Cliente'}}, 
    {"$unwind": "$itemsDespacho"},
    {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, 
        codAvance: {"$toString": '$itemsDespacho.codAvance'},
        numCoti: 1, 
        descrProductoDes: '$itemsDespacho.descrProductoDes',  descrCortaDes: '$itemsDespacho.descrCortaDes', 
        idProducto: '$itemsDespacho.idProducto',
        descrUnidadDes: '$itemsDespacho.descrUnidadDes', 
        porcDctoDes: '$itemsDespacho.porcDctoDes',
        porcIncrementoDes: '$itemsDespacho.porcIncrementoDes',
        porcIVADes: '$itemsDespacho.porcIVADes',
        cantidad: '$itemsDespacho.cantidad',
        valorDes: '$itemsDespacho.valorDes',
        despFact:'$itemsDespacho.despFact'}},
    {$project: {_id: {$concat: ['$numOrdenCompra', '$descrProductoDes', '$despFact', '$codAvance']}, 
        numCoti: 1, numOrdenCompra: 1, descrUnidadDes: 1, descrProductoDes: 1, descrCortaDes: 1, porcIVADes: 1, idProducto: 1, 
        porcDctoDes: 1, porcIncrementoDes: 1, cantidad: 1, codAvance: 1, despFact: 1, valorDes: 1}},
    {$sort: {descrProductoDes: 1}}`,
    argsQuery8: `{$match: {tipoCoti: 'Cliente'}}, 
    {"$unwind": "$itemsDespacho"},
    {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, 
        numDespacho: '$itemsDespacho.numDespacho',
        numCoti: 1, nombreUsuarioOC: 1, descrEmpresa: 1, 
        mail: 1, ciudad: 1, contacto: 1, celular: 1, ordenCompraCliente: 1, nombreUsuario: 1, 
        nombreContacto: 1, ciudadContacto: 1, cargoContacto: 1, mailContacto: 1, telContacto: 1, 
        tipoProducto: '$itemsDespacho.tipoProducto',
        fechaDespacho: '$itemsDespacho.fechaDespacho', 
        descrProductoDes: '$itemsDespacho.descrProductoDes',  descrCortaDes: '$itemsDespacho.descrCortaDes', 
        idProducto: '$itemsDespacho.idProducto',
        descrUnidadDes: '$itemsDespacho.descrUnidadDes', 
        porcDctoDes: '$itemsDespacho.porcDctoDes',
        porcIncrementoDes: '$itemsDespacho.porcIncrementoDes',
        porcIVADes: '$itemsDespacho.porcIVADes',
        cantidad: '$itemsDespacho.cantidad',
        cantidadDev: '$itemsDespacho.cantidadDev',
        valorDes: '$itemsDespacho.valorDes',
        despFact:'$itemsDespacho.despFact'}},
    {$project: {_id: {$concat: ['$numOrdenCompra', '$descrProductoDes', '$despFact', '$numDespacho']}, 
        numCoti: 1, numOrdenCompra: 1, descrUnidadDes: 1, descrProductoDes: 1, descrCorta: 1, porcIVADes: 1, fechaDespacho: 1, idProducto: 1, 
        nombreUsuarioOC: 1, mail: 1, ciudad: 1, contacto: 1, celular: 1, ordenCompraCliente: 1, nombreUsuario: 1, 
        nombreContacto: 1, ciudadContacto: 1, cargoContacto: 1, mailContacto: 1, telContacto: 1, descrEmpresa: 1, 
        tipoProducto: 1, porcDctoDes: 1, porcIncrementoDes: 1, cantidad: 1, cantidadDev: 1, numDespacho: 1, despFact: 1, valorDes: 1}},
    {$sort: {descrProductoDes: 1}}`,
    argsQuery9: `{"$unwind": "$itemsCoti"},
    {$project: {_id: {$concat: ['$numCoti', '$itemsCoti.descrProducto']}, numCoti: 1, descrEmpresa: 1, 
        descrProducto: '$itemsCoti.descrProducto',  descrCorta: '$itemsCoti.descrCorta', 
        numProductoCoti: '$itemsCoti.numProductoCoti', 
        cantidadCoti: '$itemsCoti.cantidadCoti', cantidadDespacho: '$itemsCoti.cantidadDespacho', 
        descrUnidad: '$itemsCoti.descrUnidad'}},
    {$sort: {descrProducto: 1}}`,
    argsQuery10: `{"$unwind": "$itemsDespacho"},
    {$project: {_id: {$concat: ['$numCoti', '$itemsDespacho.descrProductoDes', '$itemsDespacho.despFact', '$itemsDespacho.numDespacho']}, 
        numDespacho: '$itemsDespacho.numDespacho',
        numCoti: 1, nombreUsuarioOC: 1, descrEmpresa: 1, 
        mail: 1, ciudad: 1, contacto: 1, celular: 1, ordenCompraCliente: 1, nombreUsuario: 1, 
        nombreContacto: 1, ciudadContacto: 1, cargoContacto: 1, mailContacto: 1, telContacto: 1, 
        fechaDespacho: '$itemsDespacho.fechaDespacho', 
        descrProductoDes: '$itemsDespacho.descrProductoDes',  descrCortaDes: '$itemsDespacho.descrCortaDes', 
        idProducto: '$itemsDespacho.idProducto',
        descrUnidadDes: '$itemsDespacho.descrUnidadDes', 
        cantidad: '$itemsDespacho.cantidad',
        cantidadDev: '$itemsDespacho.cantidadDev',
        despFact:'$itemsDespacho.despFact'}},
    {$sort: {descrProductoDes: 1}}`
  }

  validarHandle = (campo1, campo1Val, campo1Sel, campo1Msg,
    campo2, campo2Val, campo2Sel, campo2Msg,
    campo3, campo3Val, campo3Sel, campo3Msg,
    campo4, campo4Val, campo4Sel, campo4Msg,
    campo5, campo5Val, campo5Sel, campo5Msg,
    campo6, campo6Val, campo6Sel, campo6Msg)=>{

    const argsAdd = this.state.argsAdd
    const errors = [];

    if(campo1!=='XXX' && (!campo1 || campo1===campo1Sel)){
      argsAdd[campo1Val] = campo1Sel;
      errors.push({path: campo1Val, message: campo1Msg});
    }
    if(campo2!=='XXX' && (!campo2 || campo2===campo2Sel)){
      argsAdd[campo2Val] = campo2Sel;
      errors.push({path: campo2Val, message: campo2Msg});
    }
    if(campo3!=='XXX' && (!campo3 || campo3===campo3Sel)){
      argsAdd[campo3Val] = campo3Sel;
      errors.push({path: campo3Val, message: campo3Msg});
    }
    if(campo4!=='XXX' && (!campo4 || campo4===campo4Sel)){
      argsAdd[campo4Val] = campo4Sel;
      errors.push({path: campo4Val, message: campo4Msg});
    }
    if(campo5!=='XXX' && (!campo5 || campo5===campo5Sel)){
      argsAdd[campo5Val] = campo5Sel;
      errors.push({path: campo5Val, message: campo5Msg});
    }
    if(campo6!=='XXX' && (!campo6 || campo6===campo6Sel)){
      argsAdd[campo6Val] = campo6Sel;
      errors.push({path: campo6Val, message: campo6Msg});
    }
    this.setState({argsAdd});
    this.setState({errorAdd: errors})
  }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        // console.log(Object.getOwnPropertyNames(this.state)[i])
        // if(typeof estado === "boolean"){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  handleChangeBuscCoti = (ev)=>{
    const argsBuscar = this.state.argsBuscar
    argsBuscar[ev.target.name] = ev.target.value
    this.setState({argsBuscar})
    this.handleBuscCoti(argsBuscar)
  }
  handleBuscCoti = async (args) => {
    let argsBuscar={}
    
    if(args.descrEmpresa){
      argsBuscar.descrEmpresa=args.descrEmpresa
    }else{
      delete argsBuscar.descrEmpresa
    }      
    if(args.numCoti){
      argsBuscar.numCoti=args.numCoti
    }else{
      delete argsBuscar.numCoti
    }

    this.setState({argsBuscCoti: argsBuscar});
  }

  showAdmin = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showAdmin: true})
  }


  showPolitica = (ev) => {
    ev.preventDefault()
    this.props.allPolitica.refetch()
    this.estadosFalse()
    this.setState({showPolitica: true})
  }
  addPolitica = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addPolitica: true})
  }
  adminPrecios = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({adminPrecios: true})
  }
  showCotizacion = (ev) => {
    ev.preventDefault()
    this.props.allCotizacionRtesCot.refetch()
    this.estadosFalse()
    this.setState({showCotizacion: true})
  }
  addCotizacion = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addCotizacion: true})
  }
  addItemCoti = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addItemCoti: true})
  }
  envCotizacion = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({envCotizacion: true})
  }  
  showAsDocCoti = (ev) => {
    ev.preventDefault()
    this.props.allCotizacionRtesAsoc.refetch()
    this.estadosFalse()
    this.setState({showAsDocCoti: true})
  }  
  showOrdenCompra = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showOrdenCompra: true})
  }
  addOrdenCompra = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addOrdenCompra: true})
  }
  addItemOC = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addItemOC: true})
  }
  showOrdenCompraFin = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showOrdenCompraFin: true})
  }
  addItemEnc = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addItemEnc: true})
  }
  showEncuesta = (ev) => {
    ev.preventDefault()
    this.props.allCotizacionRtes33.refetch()
    this.estadosFalse()
    this.setState({showEncuesta: true})
  }
  showFacturacion = (ev) => {
    ev.preventDefault()
    // this.props.allCotizacionRtesFac.refetch()
    this.estadosFalse()
    this.setState({showFacturacion: true})
  }
  showFacturacionLog = (ev) => {
    ev.preventDefault()
    // this.props.allCotizacionRtesFacLog.refetch()
    this.estadosFalse()
    this.setState({showFacturacionLog: true})
  }
  showRecaudoLog = (ev) => {
    ev.preventDefault()
    this.props.allCotizacionRtesRecLog.refetch()
    this.estadosFalse()
    this.setState({showRecaudoLog: true})
  }
  showPagosCli2 = (ev) => {
    ev.preventDefault()
    // this.props.allCotizacionRtesPagos.refetch()
    this.estadosFalse()
    this.setState({showPagosCli2: true})
  }
  showCadena = (ev) => {
    ev.preventDefault()
    // this.props.allCotizacionRtesCad.refetch()
    this.estadosFalse()
    this.setState({showCadena: true})
  }
  showInd = (ev, opcion) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showInd: true, opcion})
  }
  showTraslado = (ev) => {
    ev.preventDefault()
    this.props.allCotizacionRtesTras.refetch()
    this.estadosFalse()
    this.setState({showTraslado: true})
  }
  addTraslado = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTraslado: true})
  }
  showTrasladoFin = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showTrasladoFin: true})
  }
  addItemTras = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addItemTras: true})
  }
  showCotizacionPro = (ev) => {
    ev.preventDefault()
    this.props.allCotizacionProRtes.refetch()
    this.estadosFalse()
    this.setState({showCotizacionPro: true})
  }
  addCotizacionPro = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addCotizacionPro: true})
  }
  addItemCotiPro = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addItemCotiPro: true})
  }
  showCotizacionProve = (ev) => {
    ev.preventDefault()
    this.props.allCotizacionProRtes1.refetch()
    this.estadosFalse()
    this.setState({showCotizacionProve: true})
  }
  addCotizacionProve = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addCotizacionProve: true})
  }

  showCotizacionSelecc = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showCotizacionSelecc: true})
  }

  showOrdenCompraPro = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showOrdenCompraPro: true})
  }
  showRegPago = (ev) => {
    ev.preventDefault()
    this.props.allCotizacionRtes444.refetch()
    this.estadosFalse()
    this.setState({showRegPago: true})
  }

  handleChange = (ev, input)=>{
    const argsAdd = this.state.argsAdd
    let datoTipo = ""
    console.log(ev.target.name)
    if(input!==undefined&&ev.target.name===undefined){
      datoTipo = input.type
    } 

    if(datoTipo==='checkbox'){
      argsAdd[input.name] = input.checked
    }else{
      if(ev.target.type==='checkbox'){
        argsAdd[ev.target.name] = ev.target.checked
      }else{
        if(ev.target.name==='porcIncremento1'){
          argsAdd['porcIncremento'] = ev.target.value
        }else{
          argsAdd[ev.target.name] = ev.target.value
        }
      }
    }
    console.log(argsAdd)
    this.setState({argsAdd});
  }


  handlePolitica = async (ev, args, tituloAnt)=>{
    console.log(args)
    if((!args.titulo || !args.descrPolitica) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.titulo){
        argsAdd['titulo'] = "";
        errors.push({path: 'titulo', message: "Debe escribir el nombre de la política"});
      }
      if(!args.descrPolitica){
        argsAdd['descrPolitica'] = "";
        errors.push({path: 'descrPolitica', message: "Debe escribir el detalle de la política"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addPolitica){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        response = await this.props.createPolitica({
          variables: args
        });
        const {errors, success} = response.data.createPolitica;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var titulo = document.getElementById("titulo");
          var descrPolitica = document.getElementById("descrPolitica");
          var titulo2 = document.getElementById("titulo2");
          var parrafo2 = document.getElementById("parrafo2");
          var titulo3 = document.getElementById("titulo3");
          var parrafo3 = document.getElementById("parrafo3");
          var tipoProducto = document.getElementById("miLista");
          tipoProducto.options.selectedIndex = 0
          titulo.value = ""
          descrPolitica.value = ""
          titulo2.value = ""
          parrafo2.value = ""
          titulo3.value = ""
          parrafo3.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allPolitica.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            titulo: args.titulo,
            descrPolitica: args.descrPolitica,
            titulo2: args.titulo2,
            parrafo2: args.parrafo2,
            titulo3: args.titulo3,
            parrafo3: args.parrafo3,
            tipoProducto: args.tipoProducto,
            tituloAnt: tituloAnt,
          }
          const response = await this.props.editPolitica({
            variables: argsUpd
          });
          const {errors, success} = response.data.editPolitica;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allPolitica.refetch()
            this.estadosFalse()
            this.setState({showPolitica: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deletePolitica({
            variables: argsDel
          });
          this.props.allPolitica.refetch()
          this.estadosFalse()
          this.setState({showPolitica: true})
        }
      }
    }
  }

  handleCotizacion = async (ev, args, descrEmpresaAnt, tipoAnt)=>{
    console.log(args)
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    console.log(fechaHoraHoy)

    if(((!args.ciudadFechaEnvio || !args.descrEmpresa || args.descrEmpresa==="Seleccionar..." ||
      !args.titulo || args.titulo==="Seleccionar..." ||
      !args.zonaFranca || args.zonaFranca==="Seleccionar..." ||
      !args.gestionIngreso || args.gestionIngreso==="Seleccionar..." ||
      !args.nombreContacto || args.nombreContacto==="Seleccionar..." ||
      !args.nombreUsuario || !args.referencia || args.nombreUsuario==="Seleccionar..." ||
      !args.tiempoEntrega || args.tiempoEntrega==="Seleccionar..." ||
      !args.lugarEntrega ||
      !args.validezOferta || args.validezOferta==="Seleccionar..." ||
      !args.formaPago || args.formaPago==="Seleccionar...") && !this.state.permiteDelete) || 
      ((!args.monedaCoti || args.monedaCoti==="Seleccionar..." ||
      !args.imptoCoti || args.imptoCoti==="Seleccionar...") && this.state.addCotizacion)){
      const argsAdd = this.state.argsAdd
      const errors = [];
      // if(!args.titulo){
      //   argsAdd['titulo'] = "";
        errors.push({message: "Debe diligenciar todos los datos"});
      // }
      // if(!args.descrPolitica){
      //   argsAdd['descrPolitica'] = "";
      //   errors.push({path: 'descrPolitica', message: "Debe escribir el detalle de la política"});
      // }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addCotizacion){
        console.log(fechaHoraHoy)
        await this.props.allEmpresa.refetch()
        let allEmpresa = await this.props.allEmpresa.allEmpresa
        args.fechaCreate = fechaHoraHoy
        args.tipoCoti = 'Cliente'
        args.estadoCoti = 'Creada'
        args.descrProveed = ''
        args.observacionesOC = ''
        args.consecAvance = 0
        args.consecDespacho = 0

        let indexEmp = allEmpresa.findIndex( empresa => empresa.descrEmpresa===args.descrEmpresa )
        let consecProducto = allEmpresa[indexEmp].consecProducto?allEmpresa[indexEmp].consecProducto:0
        let consecServicio = allEmpresa[indexEmp].consecServicio?allEmpresa[indexEmp].consecServicio:0
        let consecPrograma = allEmpresa[indexEmp].consecPrograma?allEmpresa[indexEmp].consecPrograma:0
        let codEmpresa = allEmpresa[indexEmp].codEmpresa?allEmpresa[indexEmp].codEmpresa:""
        let direccion = allEmpresa[indexEmp].direccion?allEmpresa[indexEmp].direccion:""

        args.direccion = direccion

        if(!consecProducto || consecProducto===null || consecProducto===''){
          consecProducto=0
        }
        if(!consecServicio || consecServicio===null || consecServicio===''){
          consecServicio=0
        }
        if(!consecPrograma || consecPrograma===null || consecPrograma===''){
          consecPrograma=0
        }

        if(args.tipo==='Producto'){
          consecProducto=parseInt(consecProducto)+1
          args.numCoti = "COT-LCM-" + codEmpresa + "-CP-" + args.fechaCreate.substring(8, 10) + args.fechaCreate.substring(5, 7) + args.fechaCreate.substring(2, 4) + "-" + consecProducto
        }else{
          if(args.tipo==='Servicio'){
            consecServicio=parseInt(consecServicio)+1
            args.numCoti = "COT-LCM-" + codEmpresa + "-CS-" + args.fechaCreate.substring(8, 10) + args.fechaCreate.substring(5, 7) + args.fechaCreate.substring(2, 4) + "-" + consecServicio
          }else{
            consecPrograma=parseInt(consecPrograma)+1
            args.numCoti = "COT-LCM-" + codEmpresa + "-CG-" + args.fechaCreate.substring(8, 10) + args.fechaCreate.substring(5, 7) + args.fechaCreate.substring(2, 4) + "-" + consecPrograma
          }
        }
        args.archivoRecibido = ''
        console.log(args)
        response = await this.props.createCotizacion({
          variables: args
        });
        const {errors, success} = await response.data.createCotizacion;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          const argsUpdEmp = {
            tipoAct: 'EditarConsec',
            descrEmpresa: args.descrEmpresa,
            consecProducto: consecProducto,
            consecServicio: consecServicio,
            consecPrograma: consecPrograma,
            ultimaFormaPago: args.formaPago
          }
          await this.props.editEmpresa({variables: argsUpdEmp });
          // const {errors, success} = response.data.editCotizacion;

          var descrEmpresa = document.getElementById("miLista");
          descrEmpresa.options.selectedIndex = 0
          var titulo = document.getElementById("miLista1");
          titulo.options.selectedIndex = 0
          var nombreUsuario = document.getElementById("miLista2");
          nombreUsuario.options.selectedIndex = 0
          var nombreContacto = document.getElementById("miLista3");
          nombreContacto.options.selectedIndex = 0
          var referencia = document.getElementById("referencia");
          referencia.value = ""
          var tiempoEntrega = document.getElementById("miLista7");
          tiempoEntrega.options.selectedIndex = 0
          var lugarEntrega = document.getElementById("lugarEntrega");
          lugarEntrega.value = ""
          var formaPago = document.getElementById("miLista5");
          formaPago.options.selectedIndex = 0
          var validezOferta = document.getElementById("miLista6");
          validezOferta.options.selectedIndex = 0
          var observaciones = document.getElementById("observaciones");
          observaciones.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          await this.props.allEmpresa.refetch()
          this.props.allCotizacionRtesCot.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          var miLista = document.getElementById("miLista")
          let consecProducto = miLista.options[miLista.selectedIndex].attributes[0]?miLista.options[miLista.selectedIndex].attributes[0].value:0
          let consecServicio = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[1].value:0
          let consecPrograma = miLista.options[miLista.selectedIndex].attributes[2]?miLista.options[miLista.selectedIndex].attributes[2].value:0
          let codEmpresa = miLista.options[miLista.selectedIndex].attributes[3]?miLista.options[miLista.selectedIndex].attributes[3].value:""
          if(args.descrEmpresa!==descrEmpresaAnt || args.tipo!==tipoAnt){
            if(consecProducto===null || consecProducto===''){
              consecProducto=0
            }
            if(consecServicio===null || consecServicio===''){
              consecServicio=0
            }
            if(consecPrograma===null || consecPrograma===''){
              consecPrograma=0
            }
            if(args.tipo==='Producto'){
              consecProducto=parseInt(consecProducto)+1
              args.numCoti = "COT-LCM-" + codEmpresa + "-CP-" + args.fechaCreate.substring(8, 10) + args.fechaCreate.substring(5, 7) + args.fechaCreate.substring(2, 4) + "-" + consecProducto
            }else{
              if(args.tipo==='Servicio'){
                consecServicio=parseInt(consecServicio)+1
                args.numCoti = "COT-LCM-" + codEmpresa + "-CS-" + args.fechaCreate.substring(8, 10) + args.fechaCreate.substring(5, 7) + args.fechaCreate.substring(2, 4) + "-" + consecServicio
              }else{
                consecPrograma=parseInt(consecPrograma)+1
                args.numCoti = "COT-LCM-" + codEmpresa + "-CG-" + args.fechaCreate.substring(8, 10) + args.fechaCreate.substring(5, 7) + args.fechaCreate.substring(2, 4) + "-" + consecPrograma
              }
            }
          }
          if(args.estadoCoti==='Creada'){
            args.fechaAut=""
            args.usuarioAut=""
            // args.ObservacionesAut=""
          }else{
            args.fechaAut = fechaHoraHoy
            args.usuarioAut = localStorage.getItem('userLogin')
          }
          console.log(args)

          const argsUpd = { 
            _id: args._id,
            estadoCoti:args.estadoCoti,
            numCoti:args.numCoti,
            titulo: args.titulo,
            descrPolitica: args.descrPolitica,
            titulo2: args.titulo2,
            parrafo2: args.parrafo2,
            titulo3: args.titulo3,
            parrafo3: args.parrafo3,
            tipo: args.tipo,
            ciudadFechaEnvio: args.ciudadFechaEnvio,
            descrEmpresa: args.descrEmpresa,
            pais: args.pais,
            cedula: args.cedula,
            nombreUsuario: args.nombreUsuario,
            nombreContacto: args.nombreContacto,
            cargoContacto: args.cargoContacto,
            ciudadContacto: args.ciudadContacto,
            mailContacto: args.mailContacto,
            telContacto: args.telContacto,
            referencia: args.referencia,
            tiempoEntrega: args.tiempoEntrega,
            lugarEntrega: args.lugarEntrega,
            formaPago: args.formaPago,
            validezOferta: args.validezOferta,
            observaciones: args.observaciones,
            observacionesOC: args.observacionesOC?args.observacionesOC:'',
            observacionesAut: args.observacionesAut,
            usuarioAut: args.usuarioAut,
            fechaAut: args.fechaAut,
            descrProveed: '',
            ciudad: args.ciudad?args.ciudad:'',
            direccion: '',
            telefono: args.telefono?args.telefono:'',
            email: args.email?args.email:'',
            consecProducto: consecProducto,
            consecServicio: consecServicio,
            consecPrograma: consecPrograma,
            monedaCoti: args.monedaCoti?args.monedaCoti:'Pesos',
            zonaFranca: args.zonaFranca?args.zonaFranca:'No',
            gestionIngreso: args.gestionIngreso?args.gestionIngreso:'No',
            tipoAct: 'EditarCoti'
          }
          console.log(argsUpd)
          const response = await this.props.editCotizacion({
            variables: argsUpd
          });
          const {errors, success} = response.data.editCotizacion;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            
              
            this.props.allCotizacionRtesCot.refetch()
            this.estadosFalse()
            this.setState({showCotizacion: true})
          }
        }
        if(this.state.permiteDelete){
          args.estadoCoti = 'Anulada'
          args.fechaAut = fechaHoraHoy
          args.usuarioAut = localStorage.getItem('userLogin')
  
          const argsUpd = {
            _id: args._id,
            estadoCoti:args.estadoCoti,
            fechaAut: args.fechaAut,
            usuarioAut: args.usuarioAut,
            tipoAct: 'AnularCoti'
          }
          const response = await this.props.editCotizacion({
            variables: argsUpd
          });
          const {errors, success} = response.data.editCotizacion;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            // this.props.allCotizacionRtes11.refetch()
            this.estadosFalse()
            this.setState({showCotizacion: true})
          }
        }
      }
    }
  }

  handleTraslado = async (ev, args, descrEmpresaAnt)=>{
    console.log(args)
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha

    if((args.descrEmpresa==="Seleccionar..." || !args.nombreContacto || args.nombreContacto==="Seleccionar..." 
    || !args.archivoRecibido || args.archivoRecibido==="" || !args.ordenCompraCliente || args.ordenCompraCliente==="") && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      errors.push({message: "Debe diligenciar todos los datos"});
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addTraslado){
        console.log(fechaHoraHoy)
        await this.props.allEmpresa.refetch()
        let allEmpresa = await this.props.allEmpresa.allEmpresa
        args.fechaCreate = fechaHoraHoy
        args.tipoCoti = 'Traslado'
        args.estadoCoti = 'Creada'
        args.descrProveed = ''
        args.observacionesOC = ''
        args.consecAvance = 0
        args.consecDespacho = 0
        args.ordenCompraCliente = args.ordenCompraCliente?args.ordenCompraCliente:""
        args.archivoRecibido = args.archivoRecibido?args.archivoRecibido:""
        let numTraslado = await this.nextVal('traslado')
        args.numCoti="LCM-TRASLADO-" + numTraslado 

        let indexEmp = allEmpresa.findIndex( empresa => empresa.descrEmpresa===args.descrEmpresa )
        let direccion = allEmpresa[indexEmp].direccion?allEmpresa[indexEmp].direccion:""
        args.direccion = direccion
        // if(args.file!==null && args.file!==''){
          let response = await this.props.singleUpload({variables: {file: args.file}}); 
        // }
console.log(args)
        response = await this.props.createCotizacion({
          variables: args
        });
        const {errors, success} = await response.data.createCotizacion;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrEmpresa = document.getElementById("miLista");
          descrEmpresa.options.selectedIndex = 0
          var nombreContacto = document.getElementById("miLista3");
          nombreContacto.options.selectedIndex = 0
          var observaciones = document.getElementById("observaciones");
          observaciones.value = ""
          var ordenCompraCliente = document.getElementById("ordenCompraCliente");
          ordenCompraCliente.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          await this.props.allEmpresa.refetch()
          this.props.allCotizacionRtesTras.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          var miLista = document.getElementById("miLista")
          if(args.estadoCoti==='Creada'){
            args.fechaAut=""
            args.usuarioAut=""
          }else{
            args.fechaAut = fechaHoraHoy
            args.usuarioAut = localStorage.getItem('userLogin')
          }
          const argsUpd = {
            _id: args._id,
            estadoCoti:args.estadoCoti,
            descrEmpresa: args.descrEmpresa,
            nombreContacto: args.nombreContacto,
            cargoContacto: args.cargoContacto,
            ciudadContacto: args.ciudadContacto,
            mailContacto: args.mailContacto,
            telContacto: args.telContacto,
            observaciones: args.observaciones,
            ordenCompraCliente: args.ordenCompraCliente?args.ordenCompraCliente:'',
            observacionesAut: args.observacionesAut,
            usuarioAut: args.usuarioAut,
            fechaAut: args.fechaAut,
            tipoAct: 'EditarTras'
          }
          const response = await this.props.editCotizacion({
            variables: argsUpd
          });
          const {errors, success} = response.data.editCotizacion;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            if(args.estadoCoti==='Aprobada'){
              let allUsuarios = await this.props.allUsuariosRtes.allUsuariosRtes
              let indexUsu = allUsuarios.findIndex( usuarios => usuarios.nombreUsuario==='KELLI JULIETH DEL RIO PEREZ' )
              let mailUsu = allUsuarios[indexUsu].email
              // let mailUsu = 'amartinezgomez@hotmail.com'
              let nomDestino = allUsuarios[indexUsu].nombreUsuario
              let mensajeMail = args.usuarioAut + " le ha asignado una nueva solicitud de traslado según orden del cliente # " + args.ordenCompraCliente
              let cuentaDestino = mailUsu
              emailjs.send("service_dx5fufc","template_lr9h66v",{
                to_name: nomDestino,
                message: mensajeMail,
                destino: cuentaDestino,
              }, 'roL6pYMvKLsrLqGeG');
                
              this.props.allCotizacionRtesTras.refetch()
              this.estadosFalse()
              this.setState({showTraslado: true})
            }
          }
        }
        if(this.state.permiteDelete){
          args.estadoCoti = 'Cancelada'
          args.fechaAut = fechaHoraHoy
          args.usuarioAut = localStorage.getItem('userLogin')
  
          const argsUpd = {
            _id: args._id,
            estadoCoti:args.estadoCoti,
            fechaAut: args.fechaAut,
            usuarioAut: args.usuarioAut,
            tipoAct: 'AnularCoti'
          }
          const response = await this.props.editCotizacion({
            variables: argsUpd
          });
          const {errors, success} = response.data.editCotizacion;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.estadosFalse()
            this.setState({showTraslado: true})
          }
        }
      }
    }
  }

  handleItemCoti = async (ev, argsI, incremento, zonaFranca, tipo)=>{
    console.log(argsI, incremento)
    const errors = [];
    
      if((!argsI.descrProducto || !argsI.cantidadCoti || argsI.cantidadCoti===0 || argsI.descrProducto==='Seleccionar...'
        || argsI.cantidadCoti===0) && !this.state.permiteDelete){
        const argsAdd = this.state.argsAdd
        errors.push({message: "Debe diligenciar todos los datos"});
        this.setState({argsAdd});
        this.setState({errorAdd: errors})
      }else{
        let argsBuscar=""
        argsBuscar += `'numCoti': '${argsI.numCoti}', 'descrProducto': '${argsI.descrProducto}'`
        let argsBuscarIt = {}
        argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
        let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
        let regExiste = []
        regExiste = await data.allCotizacionRtes
        
        if(regExiste.length>0){
          errors.push({message: "El producto ya existe en esta cotización"});
          this.setState({errors})
          alert("!! El producto ya existe en esta cotización !!")
        }else{
          let fechaHoy = new Date()
          fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
          fechaHoy=moment(fechaHoy)
          var fecFin=moment(argsI.vigenteHasta).format('YYYY-MM-DD')
          let numDias= fechaHoy.diff(fecFin, 'days')-1 

          if(numDias>0){
            errors.push({message: "El precio del producto ya no está vigente"});
            this.setState({errors})
            alert("!! El precio del producto ya no está vigente !!")
          }else{
            if(this.state.addItemCoti){
              let porcIncre=0
              if(argsI.tipoProducto==='Producto'){
                if(incremento){
                  porcIncre=incremento
                }else{
                  porcIncre=0
                }
              }else{
                if(argsI.porcIncremento){
                  porcIncre=argsI.porcIncremento
                }else{
                  porcIncre=0
                }
              }
              let args = {}
              args._id=argsI._id
              args.moneda=argsI.monedaCoti?argsI.monedaCoti:'Pesos'
              args.cantidadCoti=argsI.cantidadCoti
              args.porcDcto=argsI.porcDcto
              args.porcIncremento=porcIncre
              args.descrProducto=argsI.descrProducto
              args.descrCorta=argsI.descrCorta
              args.numProductoCoti=parseInt(argsI.numProductoCoti)
              args.numCoti=argsI.numCoti
              args.tipoProducto=argsI.tipoProducto
              args.ficha=argsI.ficha
              args.ficha2=argsI.ficha2?argsI.ficha2:''
              args.descrUnidad = argsI.descrUnidad?argsI.descrUnidad:''
              args.abrevUnidad = ''
              args.numOrdenCompraCli = 0
              args.cantidadOC = 0
              args.cantidadDespacho = 0
              args.cantidadRecibida = 0
              args.cantidadFact = 0
              args.cantidadCompra = 0
              args.recargoTransp=argsI.recargoTransp?parseFloat(argsI.recargoTransp):0
              args.tipoAct = "CrearItem"

              args.cantidadCoti = parseInt(args.cantidadCoti)
              args.cantidadAprob = parseInt(args.cantidadCoti)
              if(args.descrProducto==='Transporte' || args.descrProducto==='Transporte producto' || args.descrProducto==='Alojamiento, alimentación y transporte'){
                if(argsI.precio){
                  if(args.moneda === 'Pesos'){
                    args.valorUniCoti = parseInt(argsI.precio)
                    args.valorUniAprob = parseInt(argsI.precio)
                  }else{
                    args.valorUniCoti = argsI.precioDolar?argsI.precioDolar:0
                    args.valorUniAprob = argsI.precioDolar?argsI.precioDolar:0
                    args.valorUniCoti = args.valorUniCoti.replace(/\,/g,'.');
                    args.valorUniCoti = parseFloat(args.valorUniCoti)
                    args.valorUniAprob = args.valorUniAprob.replace(/\,/g,'.');
                    args.valorUniAprob = parseFloat(args.valorUniAprob)
                  }
                }else{
                  args.valorUniCoti = 0
                  args.valorUniAprob = 0
                }
                if(argsI.porcIVA){
                  if(args.moneda === 'Pesos' || argsI.imptoCoti==='IVA'){
                    args.porcIVA = parseInt(argsI.porcIVA)
                  }else{
                    args.porcIVA = parseInt(argsI.porcImpto)
                  }
                }else{
                  args.porcIVA = 0
                }
              }else{
                if(args.moneda === 'Pesos'){
                  args.valorUniCoti = argsI.valorUniCoti?parseInt(argsI.valorUniCoti) + parseFloat(args.recargoTransp):0
                  args.valorUniAprob = argsI.valorUniCoti?parseInt(argsI.valorUniCoti) + parseFloat(args.recargoTransp):0
                  args.porcIVA = argsI.porcIVA?parseInt(argsI.porcIVA):0
                }else{
                  args.valorUniCoti = argsI.precioDolar?argsI.precioDolar:0
                  args.valorUniAprob = argsI.precioDolar?argsI.precioDolar:0
                  args.valorUniCoti = args.valorUniCoti.replace(/\,/g,'.');
                  args.valorUniCoti = parseFloat(args.valorUniCoti) + parseFloat(args.recargoTransp)
                  args.valorUniAprob = args.valorUniAprob.replace(/\,/g,'.');
                  args.valorUniAprob = parseFloat(args.valorUniAprob) + parseFloat(args.recargoTransp)
                  if(argsI.imptoCoti==='IVA'){
                    args.porcIVA = argsI.porcIVA?parseInt(argsI.porcIVA):0
                  }else{
                    args.porcIVA = argsI.porcImpto?parseInt(argsI.porcImpto):0
                  }
                }
              }
              args.porcDcto = args.porcDcto?parseInt(args.porcDcto):0

              if(zonaFranca && zonaFranca==='Si' && tipo==='Producto'){
                args.porcIVA = 0
              }

              let response = await this.props.editCotizacion({
                variables: args
              });
              const {errors, success} = response.data.editCotizacion;
              if (!success){
                this.setState({errorAdd: errors})
              }else{
                var descrProducto = document.getElementById("miLista44");
                descrProducto.options.selectedIndex = 0
                var cantidadCoti = document.getElementById("cantidadCoti");
                cantidadCoti.value = 0
                var porcDcto = document.getElementById("porcDcto");
                porcDcto.value = 0
                this.setState({errorAdd: []})
                this.setState({argsAdd: {}})
                let argsBuscar=""
                argsBuscar += `'numCoti': '${args.numCoti}'`
                let argsBuscarIt = {}
                argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
                let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
                this.setState({lista4: await data.allCotizacionRtes})
                this.setState({addItem: "S"})
                this.props.allCotizacionRtes.refetch()
              }
            }
          }
        }
      }
    // }
  }

  handleItemTras = async (ev, argsI)=>{
    console.log(argsI)
    const errors = [];
  
    if((!argsI.descrProducto || !argsI.cantidadCoti || argsI.cantidadCoti===0 || argsI.descrProducto==='Seleccionar...'
      || argsI.cantidadCoti===0) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      errors.push({message: "Debe diligenciar todos los datos"});
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      let argsBuscar=""
      let argsBuscar2=""
      argsBuscar += `'numCoti': '${argsI.numCoti}'`
      argsBuscar2 += `'descrProducto': '${argsI.descrProducto}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery9}, {$match: {${argsBuscar2}}}]`}
      console.log(argsBuscarIt)
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
      let regExiste = []
      regExiste = await data.allCotizacionRtes
      
      if(regExiste.length>0){
        errors.push({message: "El producto ya existe en esta solicitud"});
        this.setState({errors})
        alert("!! El producto ya existe en esta solicitud !!")
      }else{
        if(this.state.addItemTras){
          let args = {}
          args._id=argsI._id
          args.moneda=''
          args.cantidadCoti=parseInt(argsI.cantidadCoti)
          args.valorUniCoti=0
          args.valorUniAprob=0
          args.porcDcto=0
          args.porcIncremento=0
          args.porcIVA = 0
          args.descrProducto=argsI.descrProducto
          args.descrCorta=argsI.descrCorta?argsI.descrCorta:''
          args.numProductoCoti=parseInt(argsI.numProductoCoti)
          args.numCoti=argsI.numCoti
          args.tipoProducto=argsI.tipoProducto
          args.ficha=''
          args.ficha2=''
          args.descrUnidad = argsI.descrUnidad?argsI.descrUnidad:''
          args.abrevUnidad = ''
          args.numOrdenCompraCli = 0
          args.cantidadOC = 0
          args.cantidadDespacho = 0
          args.cantidadRecibida = 0
          args.cantidadFact = 0
          args.cantidadCompra = 0
          args.recargoTransp=0
          args.tipoAct = "CrearItem"

          let response = await this.props.editCotizacion({
            variables: args
          });
          const {errors, success} = response.data.editCotizacion;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            var descrProducto = document.getElementById("miLista44");
            descrProducto.options.selectedIndex = 0
            var cantidadCoti = document.getElementById("cantidadCoti");
            cantidadCoti.value = 0
            this.setState({errorAdd: []})
            this.setState({argsAdd: {}})
            let argsBuscar=""
            argsBuscar += `'numCoti': '${args.numCoti}'`
            let argsBuscarIt = {}
            argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery9}]`}
            let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
            this.setState({lista4: await data.allCotizacionRtes})
            this.setState({addItemT: "S"})
            this.props.allCotizacionRtes.refetch()
          }
        }
      }
    }
  }

  handleCotizacionPro = async (ev, args)=>{
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    if((!args.observaciones) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      errors.push({message: "Debe diligenciar las observaciones"});
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addCotizacionPro){
        args.fechaCreate = fechaHoraHoy
        args.tipoCoti = 'Proveedor'
        args.tipo = 'Solicitud'
        args.estadoCoti = 'Creada'
        args.descrProveed = ''
        args.ciudad = ''
        args.direccion = ''
        args.telefono = ''
        args.email = ''
        args.consecAvance = 0
        args.consecDespacho = 0

        let numSolicitud = await this.nextVal('solicitudCompra')

        args.numCoti = "SOL-COMPRA-" + args.fechaCreate.substring(8, 10) + args.fechaCreate.substring(5, 7) + args.fechaCreate.substring(2, 4) + "-" + numSolicitud
        args.archivoRecibido = ''

        console.log(args.numCoti)
        response = await this.props.createCotizacion({
        variables: args
        });

        const {errors, success} = response.data.createCotizacion;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var observaciones = document.getElementById("observaciones");
          observaciones.value = ""
          var observacionesOC = document.getElementById("observacionesOC");
          observacionesOC.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allCotizacionProRtes.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          if(args.estadoCoti==='Creada'){
            args.fechaAut=""
            args.usuarioAut=""
          }else{
            args.fechaAut = fechaHoraHoy
            args.usuarioAut = localStorage.getItem('userLogin')
          }
          const argsUpd = {
            _id: args._id,
            estadoCoti:args.estadoCoti,
            numCoti:args.numCoti,
            titulo: '',
            descrPolitica: '',
            titulo2: '',
            parrafo2: '',
            titulo3: '',
            parrafo3: '',
            tipo: args.tipo,
            ciudadFechaEnvio: '',
            descrEmpresa: '',
            cedula: '',
            nombreUsuario: '',
            nombreContacto: '',
            cargoContacto: '',
            ciudadContacto: '',
            mailContacto: '',
            telContacto: '',
            referencia: '',
            tiempoEntrega: '',
            lugarEntrega: '',
            formaPago: '',
            validezOferta: '',
            observaciones: args.observaciones,
            observacionesOC: args.observacionesOC,
            observacionesAut: args.observacionesAut,
            usuarioAut: args.usuarioAut,
            fechaAut: args.fechaAut,
            descrProveed: '',
            ciudad: '',
            direccion: '',
            telefono: '',
            email: '',
            consecProducto: 0,
            consecServicio: 0,
            consecPrograma: 0,
            tipoAct: 'EditarCoti'
          }
          const response = await this.props.editCotizacion({
            variables: argsUpd
          });
          const {errors, success} = response.data.editCotizacion;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allCotizacionProRtes.refetch()
            this.estadosFalse()
            this.setState({showCotizacionPro: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteCotizacion({
            variables: argsDel
          });
          this.props.allCotizacionProRtes.refetch()
          this.estadosFalse()
          this.setState({showCotizacionPro: true})
        }
      }
    }
  }

  handleItemCotiPro = async (ev, args)=>{
    console.log(args)
    const errors = [];
    if((!args.descrProducto || !args.cantidadCoti || (args.numOrdenCompraCli>0 && (args.cantidadOC>args.cantidadCoti || args.cantidadOC===0))) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      errors.push({message: "Los datos no están completos o las cantidades no son coherentes"});
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      let argsBuscar=""
      argsBuscar += `'numCoti': '${args.numCoti}', 'descrProducto': '${args.descrProducto}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionProRtes1.refetch(argsBuscarIt)
      let regExiste = []
      regExiste = await data.allCotizacionRtes
      
      if(data.allCotizacionRtes && data.allCotizacionRtes.length>0){
        errors.push({message: "El material ya existe en esta cotización"});
        this.setState({errors})
        alert("!! El material ya existe en esta cotización !!")
      }else{
        if(this.state.addItemCotiPro){
          args.moneda = 'Pesos'
          args.cantidadCoti = parseInt(args.cantidadCoti)
          args.valorUniCoti = 0
          args.cantidadAprob = parseInt(args.cantidadCoti)
          args.valorUniAprob = 0
          args.porcDcto = 0
          args.porcIncremento = 0
          args.porcIVA = 0
          if(args.numOrdenCompraCli===0){
            args.cantidadOC = 0
          }else{
            if(args.cantidadOC>args.cantidadCoti || args.cantidadOC===0){
              args.cantidadOC = args.cantidadCoti
            }else{
              args.cantidadOC = parseInt(args.cantidadOC)
            }
          }
          args.tipoAct = "CrearItem"

          let response = await this.props.editCotizacion({
            variables: args
          });
          const {errors, success} = response.data.editCotizacion;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            console.log(args)
            if(args.sacar==='S'){
              const argsUpd = {
                _id: args.idCompra,
                activo: 'N',
                tipoAct: 'EditarEstado'
              }
              console.log(argsUpd)
              const response = await this.props.editSolicCompra({
                variables: argsUpd
              });
              const {errors, success} = response.data.editSolicCompra;
              if (!success){
                this.setState({errorAdd: errors})
              }
            }
            var descrProducto = document.getElementById("miLista4");
            descrProducto.options.selectedIndex = 0
            var cantidadCoti = document.getElementById("cantidadCoti");
            cantidadCoti.value = 0
            var numOrdenCompraCli = document.getElementById("miLista");
            numOrdenCompraCli.options.selectedIndex = 0
            var cantidadOC = document.getElementById("cantidadOC");
            cantidadOC.value = 0
            var solicCompra = document.getElementById("miLista1");
            solicCompra.options.selectedIndex = 0
            this.setState({errorAdd: []})
            this.setState({argsAdd: {}})

            let argsBuscar=""
            argsBuscar += `'numCoti': '${args.numCoti}'`
            let argsBuscarIt = {}
            argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
            let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
            this.setState({lista4: await data.allCotizacionRtes})
      
            this.props.allCotizacionRtes.refetch()
            this.props.allCotizacionProRtes.refetch()
            // this.props.allSolicCompra.refetch()
          }
        }
      }
    }
  }

  handleCotizacionProve = async (ev, args)=>{
console.log(args)
// console.log(this.state)
    const a357005 = this.props.autorizacUA.findIndex( autorizac => autorizac === "357005" );

    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    const errors = [];

    let modCant='N'
    let cantidadSolic=0
    if((!args.numSolic || args.numSolic==='Seleccionar...' || 
        !args.descrProveed || args.descrProveed==='Seleccionar...' || 
        !args.descrProducto || args.descrProducto==='Seleccionar...' ||
        !args.descrUnidad || args.descrUnidad==='Seleccionar...' || args.moneda==='Seleccionar...' ||
        !args.cantidadCoti || args.cantidadCoti===0 || !args.valorUniCoti || !args.porcIVA) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      console.log(args)
      errors.push({message: "Debe diligenciar todos los datos"});
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      let argsBuscar=""
      argsBuscar += `'tipo': 'Solicitud', 'numCoti': '${args.numSolic}', 'descrProducto': '${args.descrProducto}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[{"$unwind": "$itemsCoti"},
      {$project: {_id: 1, fechaCreate: 1, numCoti: 1, usuarioCreate: 1, descrProveed: 1, numSolic: 1, tipo: 1,
        cantidadCoti: '$itemsCoti.cantidadCoti', descrProducto: '$itemsCoti.descrProducto', descrUnidad: '$itemsCoti.descrUnidad', 
        valorUniCoti: '$itemsCoti.valorUniCoti', porcIVA: '$itemsCoti.porcIVA', 
        porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento'}}, {$match: {${argsBuscar}}}]`}
      
        console.log(argsBuscarIt)
      
        let {data} = await this.props.allCotizacionProRtes2.refetch(argsBuscarIt)

      if(!data.allCotizacionRtes || data.allCotizacionRtes.length===0){
        errors.push({message: "Este material/equipo no está incluido en la solicitud de compra seleccionada"});
        this.setState({errors})
        alert("!! Este material/equipo no está incluido en la solicitud de compra seleccionada !!")
      }else{
        cantidadSolic=data.allCotizacionRtes[0].cantidadCoti
        if(data.allCotizacionRtes[0].cantidadCoti<args.cantidadCoti){
          if(a357005!==-1){
            modCant='S'
            alert("!! La cantidad es mayor a la solicitada pero el usuario SI tiene permisos para continuar !!")
          }else{
            errors.push({message: "La cantidad es mayor a la solicitada y el usuario NO tiene permisos para continuar"});
            this.setState({errors})
            alert("!! La cantidad es mayor a la solicitada y el usuario NO tiene permisos para continuar !!")
          }
        }
        if((data.allCotizacionRtes[0].cantidadCoti>=args.cantidadCoti) || (data.allCotizacionRtes[0].cantidadCoti<args.cantidadCoti && modCant==='S')){
          argsBuscar=""
          argsBuscar += `'tipo': 'Cotización', 'numSolic': '${args.numSolic}', 'descrProducto': '${args.descrProducto}', 'descrProveed': '${args.descrProveed}'`
          let argsBuscarIt = {}
          argsBuscarIt = {tipoqry: `[{"$unwind": "$itemsCoti"},
          {$project: {_id: 1, fechaCreate: 1, numCoti: 1, usuarioCreate: 1, descrProveed: 1, numSolic: 1, tipo: 1,
            cantidadCoti: '$itemsCoti.cantidadCoti', descrProducto: '$itemsCoti.descrProducto', descrUnidad: '$itemsCoti.descrUnidad', 
            valorUniCoti: '$itemsCoti.valorUniCoti', porcIVA: '$itemsCoti.porcIVA', 
            porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento'}}, {$match: {${argsBuscar}}}]`}
          
            console.log(argsBuscarIt)
          
            let {data} = await this.props.allCotizacionProRtes2.refetch(argsBuscarIt)

          if(data.allCotizacionRtes && data.allCotizacionRtes.length>0){
            errors.push({message: "Ya existe este material/equipo en la cotización de este proveedor para esta solicitud"});
            this.setState({errors})
            alert("!! Ya existe este material/equipo en la cotización de este proveedor para esta solicitud !!")
          }else{
            console.log(args.numCoti)
            if(args.numCoti){ 
              let argsBuscar=""

              argsBuscar += `
                $or: [
                  { 'tipo': 'Cotización', 'numCoti': '${args.numCoti}', 'numSolic': {$ne: '${args.numSolic}'}},
                  { 'tipo': 'Cotización', 'numCoti': '${args.numCoti}', 'numSolic': '${args.numSolic}', 'descrProveed': {$ne: '${args.descrProveed}'}}
                ]
              `
              // argsBuscar += `'tipo': 'Cotización', 'numCoti': '${args.numCoti}', 'numSolic': '{$ne: "${args.numSolic}"}'`
              let argsBuscarIt = {}
              argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}]`}
              console.log(argsBuscarIt)
              let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
          
              if(data.allCotizacionRtes && data.allCotizacionRtes.length>0){
                errors.push({message: "El número de cotización ya existe"});
                this.setState({errors})
                alert("!! El número de cotización ya existe !!")
              }
            }
            if(errors.length===0){
              if(this.state.addCotizacionProve){
                let regOK = 'S'
                let argsBuscar=""
                argsBuscar += `'tipo': 'Cotización', 'numSolic': '${args.numSolic}', 'descrProveed': '${args.descrProveed}'`
                let argsBuscarIt = {}
                argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}]`}
                let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
            
                if(data.allCotizacionRtes && data.allCotizacionRtes.length>0){
                  args._id = data.allCotizacionRtes[0]._id
                  args.numCoti = data.allCotizacionRtes[0].numCoti
                }else{
                  if(!args.numCoti || args.numCoti===''){
                    let numCotGenerica = await this.nextVal('cotGenerica')
                    args.numCoti = 'COT-' + numCotGenerica
                  }else{

                  }
                  if(!args.porcDcto || args.porcDcto===''){
                    args.porcDcto = 0
                  }
                  args.porcIncremento = 0
                  args.fechaCreate = fechaHoraHoy
                  args.tipoCoti = 'Proveedor'
                  args.tipo = 'Cotización'
                  args.estadoCoti = 'Creada'
                  args.consecAvance = 0
                  args.archivoRecibido = ''
                  // let numCotiProv = await this.nextVal('cotiProveedor')
        
                  // args.numCoti = "COT-PROV-" + args.fechaCreate.substring(8, 10) + args.fechaCreate.substring(5, 7) + args.fechaCreate.substring(2, 4) + "-" + numCotiProv
                  response = await this.props.createCotizacion({
                  variables: args
                  });
        
                  const {errors, success} = response.data.createCotizacion;
                  if (!success){
                    this.setState({errorAdd: errors})
                    regOK = 'N'
                  }else{
                    let argsBuscar=""
                    argsBuscar += `'tipo': 'Cotización', 'numSolic': '${args.numSolic}', 'descrProveed': '${args.descrProveed}'`
                    let argsBuscarIt = {}
                    argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}]`}
                    let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
                    
                    args._id = data.allCotizacionRtes[0]._id
                  }
                }

                if(regOK = 'S'){
                  // let cantidadAprob=args.cantidadCoti
                  args.cantidadCoti = parseInt(args.cantidadCoti)
                  if(args.moneda === 'Pesos'){
                    args.valorUniCoti = parseInt(args.valorUniCoti)
                  }else{
                    args.valorUniCoti = parseFloat(args.valorUniCoti)
                  }
                  // args.valorUniCoti = args.valorUniCoti
                  args.cantidadAprob = 0
                  args.valorUniAprob = 0
                  args.porcDcto = args.porcDcto?parseInt(args.porcDcto):0
                  args.porcIncremento = 0
                  args.porcIVA = args.porcIVA?parseInt(args.porcIVA):0
                  args.cantidadOC = parseInt(args.cantidadOC)
                  args.tipoAct = "CrearItem"

                  let response = await this.props.editCotizacion({
                    variables: args
                  });
                  const {errors, success} = response.data.editCotizacion;
                  if (!success){
                    this.setState({errorAdd: errors})
                    regOK = 'N'
                  }
                }

                if(regOK = 'S'){
                  var numSolic = document.getElementById("miLista3");
                  numSolic.options.selectedIndex = 0
                  var descrProveed = document.getElementById("miLista6");
                  descrProveed.options.selectedIndex = 0
                  var descrProducto = document.getElementById("miLista4");
                  descrProducto.options.selectedIndex = 0
                  var descrUnidad = document.getElementById("miLista8");
                  descrUnidad.options.selectedIndex = 0
                  var moneda = document.getElementById("miLista1");
                  moneda.options.selectedIndex = 0
                  var cantidadCoti = document.getElementById("cantidadCoti");
                  cantidadCoti.value = 0
                  var valorUniCoti = document.getElementById("valorUniCoti");
                  valorUniCoti.value = 0
                  var porcDcto = document.getElementById("porcDcto");
                  porcDcto.value = 0
                  var porcIVA = document.getElementById("porcIVA");
                  porcIVA.value = 0
                  
                  this.setState({errorAdd: []})
                  this.setState({argsAdd: {}})
                  this.props.allCotizacionProRtes2.refetch()
                }
              }else{
                if(this.state.permiteUpdate){
                }
                if(this.state.permiteDelete){
                  const argsDel = {
                    _id: args._id
                  }
                  await this.props.deleteCotizacion({
                    variables: argsDel
                  });
                  this.props.allCotizacionProRtes.refetch()
                  this.estadosFalse()
                  this.setState({showCotizacionPro: true})
                }
              }
            }
          }
        }
      }
    }
  }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  handleOrdenCompra = async (ev, args, descrEmpresaAnt, tipoAnt)=>{
    let response = await this.props.fecha({
      variables: {} 
    });
    const {fechaHoraHoy} = response.data.fecha
    // console.log(args)

    if((!args.descrEmpresa || !args.nombreUsuarioOC) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      errors.push({message: "Debe diligenciar todos los datos"});
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.permiteUpdate){
        let allUsuarios = await this.props.allUsuariosRtes.allUsuariosRtes
        let indexUsu = allUsuarios.findIndex( usuarios => usuarios.email===localStorage.getItem('userLogin') )
        let nombreUsu = allUsuarios[indexUsu].nombreUsuario
        if(args.estadoOC==='Creada'){
          args.fechaAutOC=""
          args.usuarioAutOC=""
        }else{
          args.fechaAutOC = fechaHoraHoy 
          args.usuarioAutOC = nombreUsu
        }
        args.usuarioIni = nombreUsu

        const argsUpd = {
          _id: args._id,
          estadoOC:args.estadoOC,
          descrEmpresa: args.descrEmpresaAnt,
          cedulaOC: args.cedulaOC,
          nombreUsuarioOC: args.nombreUsuarioOC,
          observacionesOC: args.observacionesOC?args.observacionesOC:'',
          observacionesAutOC: args.observacionesAutOC?args.observacionesAutOC:'',
          fechaIni: args.fechaIni,
          fechaFin: args.fechaFin,
          usuarioIni: args.usuarioIni, 
          fechaAutOC: args.fechaAutOC,
          usuarioAutOC: args.usuarioAutOC,
          // zonaFranca: args.zonaFranca,
          // gestionIngreso: args.gestionIngreso,
          tipoAct: 'EditarOC'
        }
        // console.log(argsUpd)
        const response = await this.props.editCotizacion({
          variables: argsUpd
        });
        const {errors, success} = response.data.editCotizacion;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          if(args.estadoOC==='Aprobada'){
            indexUsu = allUsuarios.findIndex( usuarios => usuarios.nombreUsuario===args.nombreUsuarioOC )
            let mailUsu = allUsuarios[indexUsu].email
            let nomDestino = args.nombreUsuarioOC
            let mensajeMail = args.usuarioAutOC + " le ha asignado la orden de compra # " + args.numOrdenCompra
            let cuentaDestino = mailUsu
            emailjs.send("service_dx5fufc","template_lr9h66v",{
              to_name: nomDestino,
              message: mensajeMail,
              destino: cuentaDestino,
            }, 'roL6pYMvKLsrLqGeG');
          }

          // this.props.allCotizacionRtes11.refetch()
          this.estadosFalse()
          this.setState({showOrdenCompra: true})
        }
      }
      if(this.state.permiteDelete){
        args.estadoOC = 'Cancelada'
        args.fechaCanOC = fechaHoraHoy
        args.usuarioCanOC = localStorage.getItem('userLogin')

        const argsUpd = {
          _id: args._id,
          estadoOC:args.estadoOC,
          fechaCanOC: args.fechaCanOC,
          usuarioCanOC: args.usuarioCanOC,
          tipoAct: 'CancelarOC'
        }
        const response = await this.props.editCotizacion({
          variables: argsUpd
        });
        const {errors, success} = response.data.editCotizacion;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          // this.props.allCotizacionRtes11.refetch()
          this.estadosFalse()
          this.setState({showOrdenCompra: true})
        }
      }
    }
  }

  handleOrdenCompraFin = async (ev, args, mensajeDespacho)=>{
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    let cedulaNuevo='', usuarioNuevo=''
    let allUsuarios = await this.props.allUsuariosRtes.allUsuariosRtes
    if((args.nombreUsuarioOCNuevo && args.nombreUsuarioOCNuevo!=='Seleccionar coordinador...') && !this.state.permiteDelete){
      let indexUsu = allUsuarios.findIndex( usuarios => usuarios.email===localStorage.getItem('userLogin') )
      let nombreUsu = allUsuarios[indexUsu].nombreUsuario
      args.fechaAutOC = fechaHoraHoy
      args.usuarioAutOC = nombreUsu
      args.usuarioIni = nombreUsu
      if(args.nombreUsuarioOCNuevo!=='Seleccionar coordinador...'){
        cedulaNuevo = args.cedulaOCNuevo
        usuarioNuevo = args.nombreUsuarioOCNuevo
      }else{
        cedulaNuevo = args.cedulaOC
        usuarioNuevo = args.nombreUsuarioOC
      }

      const argsUpd = {
        _id: args._id,
        cedulaOC: cedulaNuevo,
        nombreUsuarioOC: usuarioNuevo,
        fechaAutOC: fechaHoraHoy,
        usuarioAutOC: args.usuarioAutOC,
        tipoAct: 'EditarCoo'
      }
      const response = await this.props.editCotizacion({
        variables: argsUpd
      });
      const {errors, success} = response.data.editCotizacion;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        // this.props.allCotizacionRtes11.refetch()
        this.estadosFalse()
        this.setState({showOrdenCompraFin: true})
      }
    }else{
      if((!args.contactoEncuesta || (args.estadoOC!=='Aprobada' && !args.fechaFinReal)) && !this.state.permiteDelete){
        if(args.estadoOC!=='Aprobada' && !args.fechaFinReal){
          const argsAdd = this.state.argsAdd
          const errors = [];
          errors.push({message: "Debe seleccionar la fecha fin real"});
          this.setState({argsAdd});
          this.setState({errorAdd: errors})
        }else{
          const argsAdd = this.state.argsAdd
          const errors = [];
          errors.push({message: "Debe diligenciar los datos del contacto para la encuesta"});
          this.setState({argsAdd});
          this.setState({errorAdd: errors})
        }
      }else{
        console.log(args.valorFact, args.totalOC, args.totalFact)
        // if((args.valorFact && args.valorFact>0 && (args.valorFact>(args.totalOC - args.totalFact))) && !this.state.permiteDelete){
        if(args.estadoOC==='PendienteFac'){
          const argsAdd = this.state.argsAdd
          const errors = [];
          errors.push({message: "Existen cantidades despachadas pendientes por facturar"});
          this.setState({argsAdd});
          this.setState({errorAdd: errors})
        }else{
          if(args.estadoOC==='Prefactura' && mensajeDespacho==='EXISTEN CANTIDADES PENDIENTES POR DESPACHAR' && (!args.observacionesFin || args.observacionesFin==='' ||args.observacionesFin===null)){
            const argsAdd = this.state.argsAdd
            const errors = [];
            errors.push({message: "Si va a cerrar el proceso con despachos pendientes debe escribir la justificación en el campo observaciones finales"});
            this.setState({argsAdd});
            this.setState({errorAdd: errors})
          }else{
            if(this.state.permiteUpdate){
              args.fechaEjec = fechaHoraHoy
              args.fechaSolic = fechaHoraHoy
              args.usuarioEjec = localStorage.getItem('userLogin')
              if(args.valorFact && args.valorFact>0){
                args.consecAvance+=1
              }
              if(args.estadoOC==='Aprobada'){
                args.fechaFinReal = null
              }
              const argsUpd = {
                _id: args._id,
                estadoOC:args.estadoOC,
                observacionesFin: args.observacionesFin?args.observacionesFin:"",
                fechaFinReal: args.fechaFinReal,
                contactoEncuesta: args.contactoEncuesta?args.contactoEncuesta:"",
                cedulaEncuesta: args.cedulaEncuesta?args.cedulaEncuesta:"",
                telefonoEncuesta: args.telefonoEncuesta?args.telefonoEncuesta:"",
                emailEncuesta: args.emailEncuesta?args.emailEncuesta:"",
                actaInicial: args.actaInicial?args.actaInicial:"",
                actaFinal: args.actaFinal?args.actaFinal:"",
                informe: args.informe?args.informe:"",
                ordenPago: args.ordenPago?args.ordenPago:"",
                archivoEncuesta: args.archivoEncuesta?args.archivoEncuesta:"",
                usuarioEjec: args.usuarioEjec,
                diasImportacion: args.diasImportacion?args.diasImportacion:0,
                fechaEjec: fechaHoraHoy,
                tipoAct: 'EditarFin',
                modArch1: "N",
                modArch2: "N",
                modArch3: "N",
                modArch4: "N", 
              } 
              if(args.file!==null && args.file!==''){
                argsUpd.modArch1 = "S"
                let response = await this.props.singleUpload({variables: {file: args.file}}); 
              }
              if(args.file1!==null && args.file1!==''){ 
                argsUpd.modArch2 = "S"
                let response = await this.props.singleUpload({variables: {file: args.file1}}); 
              }
              if(args.file2!==null && args.file2!==''){
                argsUpd.modArch3 = "S"
                let response = await this.props.singleUpload({variables: {file: args.file2}}); 
              }
              if(args.file3!==null && args.file3!==''){
                argsUpd.modArch4 = "S"
                let response = await this.props.singleUpload({variables: {file: args.file3}}); 
              }
              
              const response = await this.props.editCotizacion({
                variables: argsUpd
              });
              const {errors, success} = response.data.editCotizacion;
              if (!success){
                this.setState({errorAdd: errors})
              }else{
                if(args.valorFact && args.valorFact>0){
                  const argsUpdFact = {
                    _id: args._id,
                    valorFact: parseFloat(args.valorFact).toFixed(2),
                    valorPagado: 0,
                    numFactura: '',
                    numAvance: parseInt(args.consecAvance),
                    archivoFactura: '',
                    ordenPago: args.ordenPago?args.ordenPago:"",
                    usuarioSolic: args.usuarioEjec,
                    fechaSolic: fechaHoraHoy,
                    usuarioFact: '',
                    fechaFact: null,
                    usuarioPago: '',
                    fechaPago: null,
                    modArch5: "N",
                    tipoAct: "CrearItemFact"
                  }            
                  if(args.file4!==null && args.file4!==''){
                    argsUpdFact.modArch5 = "S"
                    let response = await this.props.singleUpload({variables: {file: args.file4}}); 
                  }

                  let response = await this.props.editCotizacion({
                    variables: argsUpdFact
                  });
                  const {errors, success} = response.data.editCotizacion;
                  if (!success){
                    this.setState({errorAdd: errors})
                  }else{
                    const argsUpdConsec = {
                      _id: args._id,
                      consecAvance:args.consecAvance,
                      tipoAct: 'EditarConsec',
                    }
                    const response = await this.props.editCotizacion({
                      variables: argsUpdConsec
                    });
                    const {errors, success} = response.data.editCotizacion;
                    
                    if(args.estadoOC==='Prefactura' && mensajeDespacho==='EXISTEN CANTIDADES PENDIENTES POR DESPACHAR' && (!args.observacionesFin || args.observacionesFin==='' ||args.observacionesFin===null)){
                      let mailFactura = ''
                      if(this.props.getParametro.getParametro){
                        mailFactura = 'felipe.albarracin@lubricaciondeclasemundial.com'
                      }
                      // mailFactura = 'amartinezgomez@hotmail.com'
                      let indexUsu = allUsuarios.findIndex( usuarios => usuarios.email===args.usuarioEjec )
                      let nomDestino = 'Felipe'
                      let mensajeMail = allUsuarios[indexUsu].nombreUsuario + " ha cerrado la OC # " + args.numOrdenCompra + " con despachos pendientes y con la siguiente observación: " + args.observacionesFin
                      let cuentaDestino = mailFactura
                      if(cuentaDestino){
                        emailjs.send("service_dx5fufc","template_upf8s4f",{
                          to_name: nomDestino,
                          message: mensajeMail,
                          destino: cuentaDestino,
                        }, 'roL6pYMvKLsrLqGeG');   
                      }  
                    }
                  }
                }

                // this.props.allCotizacionRtes22.refetch()
                this.estadosFalse()
                this.setState({showOrdenCompraFin: true})
              }
            }
          }
        }
        if(this.state.permiteDelete){
          args.estadoOC = 'Cancelada'
          args.estadoCoti = 'Cancelada'
          args.fechaCanOC = fechaHoraHoy
          args.usuarioCanOC = localStorage.getItem('userLogin')

          const argsUpd = {
            _id: args._id,
            estadoOC:args.estadoOC,
            estadoCoti:args.estadoCoti,
            fechaCanOC: args.fechaCanOC,
            usuarioCanOC: args.usuarioCanOC,
            tipoAct: 'CancelarOC'
          }
          const response = await this.props.editCotizacion({
            variables: argsUpd
          });
          const {errors, success} = response.data.editCotizacion;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            // this.props.allCotizacionRtes11.refetch()
            this.estadosFalse()
            this.setState({showOrdenCompraFin: true})
          }
        }
      }
    }
  }

  handleTrasladoFin = async (ev, args)=>{
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    let allUsuarios = await this.props.allUsuariosRtes.allUsuariosRtes
    if(this.state.permiteUpdate){
      args.fechaEjec = fechaHoraHoy
      args.fechaSolic = fechaHoraHoy
      args.usuarioEjec = localStorage.getItem('userLogin')
      if(args.estadoCoti==='Aprobada'){
        args.fechaFinReal = null
      }
      const argsUpd = {
        _id: args._id,
        estadoCoti:args.estadoCoti,
        observacionesFin: args.observacionesFin?args.observacionesFin:"",
        fechaFinReal: args.fechaFinReal,
        informe: args.informe?args.informe:"",
        usuarioEjec: args.usuarioEjec,
        fechaEjec: fechaHoraHoy,
        tipoAct: 'EditarFinTras',
        modArch4: "N"
      } 
      if(args.file3!==null && args.file3!==''){
        argsUpd.modArch4 = "S"
        let response = await this.props.singleUpload({variables: {file: args.file3}}); 
      }
      
      const response = await this.props.editCotizacion({
        variables: argsUpd
      });
      const {errors, success} = response.data.editCotizacion;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        this.estadosFalse()
        this.setState({showTrasladoFin: true})
      }
    }
    if(this.state.permiteDelete){
      args.estadoOC = 'Cancelada'
      args.fechaCanOC = fechaHoraHoy
      args.usuarioCanOC = localStorage.getItem('userLogin')

      const argsUpd = {
        _id: args._id,
        estadoOC:args.estadoOC,
        fechaCanOC: args.fechaAutOC,
        usuarioCanOC: args.usuarioAutOC,
        tipoAct: 'CancelarOC'
      }
      const response = await this.props.editCotizacion({
        variables: argsUpd
      });
      const {errors, success} = response.data.editCotizacion;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        this.estadosFalse()
        this.setState({showTrasladoFin: true})
      }
    }
  }

  handleFacturacion = async (ev, args)=>{
    console.log(args)
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    if((!args.numFactura || !args.venceFact) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      errors.push({message: "Debe escribir el número de la factura y seleccionar la fecha de vencimiento de la factura"});
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.permiteUpdate){
        // if(!args.fechaFact || args.fechaFact===null || args.fechaFact===''){
          args.fechaFact = fechaHoraHoy
        // }
        args.usuarioFact = localStorage.getItem('userLogin')

        const argsUpd = {
          _id: args._id,
          numOrdenCompra: parseInt(args.numOrdenCompra),
          archivoFactura: args.archivoFactura?args.archivoFactura:'',
          numFactura: args.numFactura,
          venceFact: args.venceFact,
          trmFactura: args.trmFactura?args.trmFactura.replace(/\,/g,'.'):0,
          numAvance: parseInt(args.numAvance),
          usuarioFact: args.usuarioFact,
          fechaFact: fechaHoraHoy, 
          tipoAct: 'EditarItemFact',
          modArch1: 'N'
        }

        if(args.file!==null && args.file!==''){
          argsUpd.modArch1 = 'S'
          let response = await this.props.singleUpload({variables: {file: args.file}}); 
        }
        const response = await this.props.editCotizacion({
          variables: argsUpd
        });
        const {errors, success} = response.data.editCotizacion;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          await actCartera(
            args.descrEmpresa,
            {
              allCotizacionRtes: this.props.allCotizacionRtesActFact, 
              editEmpresa: this.props.editEmpresa 
            }
          );
                     
        }

        this.props.allCotizacionRtesFac.refetch()
        this.estadosFalse()
        this.setState({showFacturacion: true})
      }
    }
  }



  handleRegPago = async (ev, args)=>{
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    console.log(args)
    if(!args.archivoFactura && args.estadoOC==='Pagada'){
      const argsAdd = this.state.argsAdd
      const errors = [];
      errors.push({message: "Debe seleccionar el archivo de la factura"}); 
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.permiteUpdate){
          args.fechaFac = fechaHoraHoy
          args.usuarioFac = localStorage.getItem('userLogin')
          if(args.estadoOC==='Anulada'){
            args.valorPagado=0
          }
          let allUsuarios = this.props.allUsuarios.allUsuarios
          let nombreUsuario = ''
          let indexUsu = allUsuarios.findIndex( usuario => usuario.email===localStorage.getItem('userLogin') )
          if(indexUsu!==-1){
            nombreUsuario=allUsuarios[indexUsu].nombreUsuario
          }
        const argsUpd = {
          _id: args._id,
          estadoOC:args.estadoOC,
          archivoFactura: args.archivoFactura?args.archivoFactura:'',
          numFactura: '',
          valorPagado: args.valorPagado?args.valorPagado:0,
          usuarioFac: nombreUsuario,
          fechaFac: args.fechaFac,
          tipoAct: 'EditarFactProv',
          modArch1: 'N'
        }
        if(args.file!==null && args.file!==''){
          argsUpd.modArch1 = 'S'
          let response = await this.props.singleUpload({variables: {file: args.file}}); 
        }
        console.log(argsUpd)

        const response = await this.props.editCotizacion({
          variables: argsUpd
        });
        const {errors, success} = response.data.editCotizacion;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          this.props.allCotizacionRtes444.refetch()
          this.estadosFalse()
          this.setState({showRegPago: true})
        }
      }
    }
  }


  handleItemOC = async (ev, args)=>{
    console.log(args)
    const errors = [];
    if((!args.descrProducto || !args.cantidadAprob || !args.valorUniAprob || !args.porcIVA || !args.porcDcto) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      errors.push({message: "Debe diligenciar todos los datos"});
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      let argsBuscar=""
      argsBuscar += `numOrdenCompra: '${args.numOrdenCompra}', 'descrProducto': '${args.descrProducto}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionRtes00.refetch(argsBuscarIt)
      let regExiste = []
      regExiste = await data.allCotizacionRtes
      
      if(regExiste.length>0){
        errors.push({message: "El producto ya existe en esta orden de compra"});
        this.setState({errors})
        alert("!! El producto ya existe en esta orden de compra !!")
      }else{
        if(this.state.addItemOC){
          args.cantidadAprob = parseInt(args.cantidadAprob)
          args.valorUniAprob = parseInt(args.valorUniAprob)
          args.porcDcto = args.porcDcto?parseInt(args.porcDcto):0
          args.porcIncremento = 0
          args.porcIVA = args.porcIVA?parseInt(args.porcIVA):0
          args.moneda = 'Pesos'
          args.tipoAct = "CrearItem"

          let response = await this.props.editCotizacion({
            variables: args
          });
          const {errors, success} = response.data.editCotizacion;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            var descrProducto = document.getElementById("miLista");
            descrProducto.options.selectedIndex = 0
            var cantidadAprob = document.getElementById("cantidadAprob");
            cantidadAprob.value = 0
            var valorUniAprob = document.getElementById("valorUniAprob");
            valorUniAprob.value = 0
            var porcDcto = document.getElementById("porcDcto");
            porcDcto.value = 0
            var porcIVA = document.getElementById("porcIVA");
            porcIVA.value = 0
            this.setState({errorAdd: []})
            this.setState({argsAdd: {}})
            this.props.allCotizacionRtes00.refetch()
          }
        }
      }
    }
  }

  handleItemEnc = async (ev, args)=>{
    console.log(args)
    const errors = [];
    if((!args.pregunta || !args.respuesta) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      errors.push({message: "Debe diligenciar todos los datos"});
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      let argsBuscar=""
      argsBuscar += `numOrdenCompra: '${args.numOrdenCompra}', 'pregunta': '${args.pregunta}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[${this.state.argsQuery2}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.CotizacionRtes00.refetch(argsBuscarIt)
      let regExiste = []
      regExiste = await data.allCotizacionRtes
      
      if(regExiste.length>0){
        errors.push({message: "La pregunta ya existe en esta encuesta"});
        this.setState({errors})
        alert("!! La pregunta ya existe en esta encuesta !!")
      }else{
        if(this.state.addItemEnc){
          args.tipoAct = "CrearItemEncuesta"

          let response = await this.props.editCotizacion({
            variables: args
          });
          const {errors, success} = response.data.editCotizacion;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            var pregunta = document.getElementById("pregunta");
            pregunta.value =''
            var respuesta = document.getElementById("respuesta");
            respuesta.value = ''
            this.setState({errorAdd: []})
            this.setState({argsAdd: {}})
            this.props.allCotizacionRtes00.refetch()
          }
        }
      }
    }
  }

  handleUpdAsDocCoti = async (ev, idListaP, EnvRec)=>{
    let listImg = ev.target.files

    if(listImg.length===1){
      if(idListaP.numCoti){
        document.body.style.cursor = 'wait'

        let movColecc = []
        let argsUpd = {}
        // if(listImg!==null && listImg!==''){
          let response = await this.props.singleUpload({variables: {file: listImg[0]}}); 
        // }
        if(EnvRec==='E'){
            argsUpd = {
            "tipoAct": 'EditarArchEnv',
            "archivoEnviado": listImg[0].name,
            "_id": idListaP._id
          }
        }else{
          argsUpd = {
            "tipoAct": 'EditarArchRec',
            "archivoRecibido": listImg[0].name,
            "_id": idListaP._id
          }
        }
        movColecc.push(argsUpd)

        let numDocCRUD = 0
        let totDocCRUD = 1
        let argsCrud = []
        let crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editCotizacion)
        }

        argsCrud[numDocCRUD] = movColecc[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editCotizacion
        await this.updColecc(crudColecc, argsCrud, totDocCRUD)

        document.body.style.cursor = 'default'
        alert("!! Documento cargado !!")
        const argsBuscCoti = this.state.argsBuscCoti
        this.setState({argsBuscCoti});
        this.handleBuscCoti(argsBuscCoti)
  
        if (this.state.showAsDocCoti) {
          this.props.allCotizacionRtesAsoc.refetch()
        }
        if (this.state.envCotizacion) {
        }
      }else{
        alert("!! Por favor seleccione la cotización !!")
      }
    }else{
      console.log(listImg[0].length)
      alert("!! Solo le puede asociar un archivo enviado a cada cotización !!")
    }
  }

  handleElimAsDocCoti = async (ev, idListaP, EnvRec)=>{
    console.log(EnvRec, idListaP)
    let file = ""
    if(idListaP.numCoti){
      if(EnvRec==='E'){
        file = idListaP.archivoEnviado
      }else{
        file = idListaP.archivoRecibido
      }
      let movColecc = []
      let argsUpd = {}
      if(EnvRec==='E'){
        argsUpd = {
          "tipoAct": 'ElimArchEnv',
          "archivoEnviado": file,
          "_id": idListaP._id
        }
      }else{
        argsUpd = {
          "tipoAct": 'ElimArchRec',
          "archivoRecibido": file,
          "_id": idListaP._id
        }
      }
      movColecc.push(argsUpd)

      let numDocCRUD = 0
      let totDocCRUD = 1
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editCotizacion)
      }

      argsCrud[numDocCRUD] = movColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editCotizacion

      await this.updColecc(crudColecc, argsCrud, totDocCRUD)
 
      document.body.style.cursor = 'default'
      alert("!! Documento eliminado !!")

      const argsBuscCoti = this.state.argsBuscCoti
      this.setState({argsBuscCoti});
      this.handleBuscCoti(argsBuscCoti)

      if (this.state.showAsDocCoti) {
        this.props.allCotizacionRtesAsoc.refetch()
      }
      if (this.state.envCotizacion) {
      }
    }else{
      alert("!! Por favor seleccione el documento a eliminar !!")
    }
  }


  handleSelnombreUsuario = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreUsuario'] = miLista.options[miLista.selectedIndex].text
    argsAdd['cedula'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['ciudad'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['email'] = miLista.options[miLista.selectedIndex].attributes[2].value
    argsAdd['telefono'] = miLista.options[miLista.selectedIndex].attributes[3].value

    this.setState({argsAdd});
  } 

  handleSelEntrega = () => {
    var miLista = document.getElementById("miLista7");
    const argsAdd = this.state.argsAdd
    argsAdd['tiempoEntrega'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelPago = () => {
    var miLista = document.getElementById("miLista5");
    const argsAdd = this.state.argsAdd
    argsAdd['formaPago'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelOferta = () => {
    var miLista = document.getElementById("miLista6");
    const argsAdd = this.state.argsAdd
    argsAdd['validezOferta'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelDescrEmpresa = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['descrEmpresa'] = miLista.options[miLista.selectedIndex].text
    argsAdd['consecProducto'] = miLista.options[miLista.selectedIndex].attributes[0]?miLista.options[miLista.selectedIndex].attributes[0].value:0
    argsAdd['consecServicio'] = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[1].value:0
    argsAdd['consecPrograma'] = miLista.options[miLista.selectedIndex].attributes[2]?miLista.options[miLista.selectedIndex].attributes[2].value:0
    argsAdd['codEmpresa'] = miLista.options[miLista.selectedIndex].attributes[3]?miLista.options[miLista.selectedIndex].attributes[3].value:0
    argsAdd['pais'] = miLista.options[miLista.selectedIndex].attributes[4]?miLista.options[miLista.selectedIndex].attributes[4].value:'Colombia'
    this.setState({argsAdd});
  } 
  handleSelDescrEmpresaOC = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['descrEmpresa'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  } 
  handleSelDescrProducto = () => { 
    var miLista = document.getElementById("miLista44");
  console.log(miLista.options[miLista.selectedIndex].attributes[4].value)
    const argsAdd = this.state.argsAdd
    argsAdd['descrProducto'] = miLista.options[miLista.selectedIndex].value
    argsAdd['tipoProducto'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['ficha'] = miLista.options[miLista.selectedIndex].attributes[1].value?miLista.options[miLista.selectedIndex].attributes[1].value:''
    argsAdd['descrUnidad'] = miLista.options[miLista.selectedIndex].attributes[2].value?miLista.options[miLista.selectedIndex].attributes[2].value:''
    argsAdd['valorUniCoti'] = miLista.options[miLista.selectedIndex].attributes[3].value?miLista.options[miLista.selectedIndex].attributes[3].value:0
    argsAdd['porcIVA'] = miLista.options[miLista.selectedIndex].attributes[4].value?miLista.options[miLista.selectedIndex].attributes[4].value:0
    argsAdd['precioDolar'] = miLista.options[miLista.selectedIndex].attributes[5].value?miLista.options[miLista.selectedIndex].attributes[5].value:0
    argsAdd['porcImpto'] = miLista.options[miLista.selectedIndex].attributes[6].value?miLista.options[miLista.selectedIndex].attributes[6].value:0
    argsAdd['ficha2'] = miLista.options[miLista.selectedIndex].attributes[7].value?miLista.options[miLista.selectedIndex].attributes[7].value:''
    argsAdd['vigenteHasta'] = miLista.options[miLista.selectedIndex].attributes[8].value?miLista.options[miLista.selectedIndex].attributes[8].value:''
    argsAdd['estado'] = miLista.options[miLista.selectedIndex].attributes[9].value?miLista.options[miLista.selectedIndex].attributes[9].value:''
    argsAdd['numProductoCoti'] = miLista.options[miLista.selectedIndex].attributes[10].value
    argsAdd['descrCorta'] = miLista.options[miLista.selectedIndex].attributes[11].value

    console.log(argsAdd)
    this.setState({argsAdd});
  }
  handleSelDescrProducto2 = () => {
    var miLista = document.getElementById("miLista4");
    const argsAdd = this.state.argsAdd
    argsAdd['descrProducto'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['tipoProducto'] = miLista.options[miLista.selectedIndex].attributes[0].value
    console.log(argsAdd)
    this.setState({argsAdd});
  } 
  handleSelDescrProducto3 = () => {
    var miLista = document.getElementById("miLista4");
    const argsAdd = this.state.argsAdd
    argsAdd['descrProducto'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['tipoProducto'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['numOrdenCompraCli'] = miLista.options[miLista.selectedIndex].attributes[2].value?miLista.options[miLista.selectedIndex].attributes[2].value:0
    argsAdd['cantidadOC'] = miLista.options[miLista.selectedIndex].attributes[3].value?miLista.options[miLista.selectedIndex].attributes[3].value:0
    console.log(argsAdd)
    this.setState({argsAdd});
  } 
  handleSelOC = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    if(miLista.options[miLista.selectedIndex].value==='Sin Proyecto'){
      argsAdd['numOrdenCompraCli'] = 0
    }else{
      argsAdd['numOrdenCompraCli'] = miLista.options[miLista.selectedIndex].value
    }
    console.log(argsAdd)
    this.setState({argsAdd});
  } 

  handleSelCompra = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    if(miLista.options[miLista.selectedIndex].value==='Consultar...'){
      argsAdd['producto'] = ""
      argsAdd['idCompra'] = ""
    }else{
      argsAdd['producto'] = miLista.options[miLista.selectedIndex].value
      argsAdd['idCompra'] = miLista.options[miLista.selectedIndex].attributes[0].value
    }
    console.log(argsAdd)
    this.setState({argsAdd});
  }

  handleSelDescrUnidad = () => {
    var miLista = document.getElementById("miLista8");
    const argsAdd = this.state.argsAdd
    argsAdd['descrUnidad'] = miLista.options[miLista.selectedIndex].text
    argsAdd['abrevUnidad'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  } 
  handleSelDescrPolitica = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['descrPolitica'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['tipo'] = miLista.options[miLista.selectedIndex].attributes[1].value
    argsAdd['titulo'] = miLista.options[miLista.selectedIndex].text
    argsAdd['titulo2'] = miLista.options[miLista.selectedIndex].attributes[2].value?miLista.options[miLista.selectedIndex].attributes[2].value:""
    argsAdd['parrafo2'] = miLista.options[miLista.selectedIndex].attributes[3].value?miLista.options[miLista.selectedIndex].attributes[3].value:""
    argsAdd['titulo3'] = miLista.options[miLista.selectedIndex].attributes[4].value?miLista.options[miLista.selectedIndex].attributes[4].value:""
    argsAdd['parrafo3'] = miLista.options[miLista.selectedIndex].attributes[5].value?miLista.options[miLista.selectedIndex].attributes[5].value:""
    this.setState({argsAdd});
  } 

  handleSelDescrContacto = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreContacto'] = miLista.options[miLista.selectedIndex].text
    argsAdd['ciudadContacto'] = miLista.options[miLista.selectedIndex].attributes[0]?miLista.options[miLista.selectedIndex].attributes[0].value:""
    argsAdd['cargoContacto'] = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[1].value:""
    argsAdd['mailContacto'] = miLista.options[miLista.selectedIndex].attributes[2]?miLista.options[miLista.selectedIndex].attributes[2].value:""
    argsAdd['telContacto'] = miLista.options[miLista.selectedIndex].attributes[3]?miLista.options[miLista.selectedIndex].attributes[3].value:""

    this.setState({argsAdd});
  } 

  handleSelDescrProveed = () => {
    console.log(document.getElementById("miLista6"))

    var miLista = document.getElementById("miLista6");
    const argsAdd = this.state.argsAdd
    argsAdd['descrProveed'] = miLista.options[miLista.selectedIndex].text
    argsAdd['ciudad'] = miLista.options[miLista.selectedIndex].attributes[0]?miLista.options[miLista.selectedIndex].attributes[0].value:""
    argsAdd['direccion'] = miLista.options[miLista.selectedIndex].attributes[1]?miLista.options[miLista.selectedIndex].attributes[1].value:""
    argsAdd['telefono'] = miLista.options[miLista.selectedIndex].attributes[2]?miLista.options[miLista.selectedIndex].attributes[2].value:""
    argsAdd['email'] = miLista.options[miLista.selectedIndex].attributes[3]?miLista.options[miLista.selectedIndex].attributes[3].value:""
    argsAdd['cedula'] = miLista.options[miLista.selectedIndex].attributes[4]?miLista.options[miLista.selectedIndex].attributes[4].value:""
    argsAdd['nombreContacto'] = miLista.options[miLista.selectedIndex].attributes[5]?miLista.options[miLista.selectedIndex].attributes[5].value:""

    console.log(argsAdd)
    this.setState({argsAdd});
    console.log(this.state.argsAdd)
  }

  handleSelSolicitud = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['numSolic'] = miLista.options[miLista.selectedIndex].text
    argsAdd['observacionesOC'] = miLista.options[miLista.selectedIndex].attributes[0]?miLista.options[miLista.selectedIndex].attributes[0].value:""
    this.setState({argsAdd});
  }
  handleSelMoneda = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['moneda'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }
  
  handleSelMoneda2 = () => {
    var miLista = document.getElementById("miLista55");
    const argsAdd = this.state.argsAdd
    argsAdd['monedaCoti'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelImpto = () => {
    var miLista = document.getElementById("miLista77");
    const argsAdd = this.state.argsAdd
    argsAdd['imptoCoti'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelSiNo = (ev, nameLista) => {
    var miLista = document.getElementById(nameLista);
    const argsAdd = this.state.argsAdd
    if (nameLista==='zonaFranca'){
      argsAdd['zonaFranca'] = miLista.options[miLista.selectedIndex].text
    }
    if (nameLista==='gestionIngreso'){
      argsAdd['gestionIngreso'] = miLista.options[miLista.selectedIndex].text
    }  
    this.setState({argsAdd});
  }

  handleChangeBuscCad = (ev)=>{
    const argsBuscCad = this.state.argsBuscCad
    console.log(this.state.argsBuscCad)
    console.log(ev.target.name)
    if(ev.target.name === "numDocum"){
      var numDocum = document.getElementById("numDocum");
      if(ev.target.value<=0){
        numDocum.value = ""
        argsBuscCad[ev.target.name] = ""
      }else{
        argsBuscCad[ev.target.name] = ev.target.value
      }
    }else{
      if(ev.target.name==="descrEmpresa"){
        argsBuscCad["descrEmpresa"] = ev.target.value
      }else{
        if(ev.target.name==="numCoti"){
          argsBuscCad["numCoti"] = ev.target.value
        }else{
          if(ev.target.name==="numOrdenCompra"){
            argsBuscCad["numOrdenCompra"] = ev.target.value
          }else{
            if(ev.target.name==="nombreUsuario"){
              argsBuscCad["nombreUsuario"] = ev.target.value
            }else{
              if(ev.target.name==="nombreUsuarioOC"){
                argsBuscCad["nombreUsuarioOC"] = ev.target.value
              }else{
                if(ev.target.name==="estadoCoti"){
                  argsBuscCad["estadoCoti"] = ev.target.value
                }else{
                  if(ev.target.name==="ordenCompraCliente"){
                    argsBuscCad["ordenCompraCliente"] = ev.target.value
                  }else{
                    if(ev.target.name==="totalOC"){
                      argsBuscCad["totalOC"] = ev.target.value
                    }else{
                      if(ev.target.name==="numFactura"){
                        argsBuscCad["numFactura"] = ev.target.value
                      }else{
                        if(ev.target.name==="pais"){
                          argsBuscCad["pais"] = ev.target.value
                        }else{
                          argsBuscCad[ev.target.name] = ev.target.value
                        }
                      }
                    }
                  }                 
                } 
              }           
            }
          }
        }
      }
      // argsBuscProg[ev.target.name] = ev.target.value
    }
    console.log(argsBuscCad)
    this.setState({argsBuscCad});
    this.handleBuscCad(argsBuscCad)
  }

  showDescRemision = async (ev) => {
    if(this.state.idLista){
      const idListaP = this.state.idLista
      if(idListaP.tipo==='Producto'){
        document.body.style.cursor = 'wait'

        let lista5 = []
        let argsBuscar=""
        argsBuscar += `numOrdenCompra: '${idListaP.numOrdenCompra}'`
        let argsBuscarIt = {}
        argsBuscarIt = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
        let {data} = await this.props.allCotizacionRtes00.refetch(argsBuscarIt)
        let registros = await data.allCotizacionRtes
        lista5 = registros

        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
        let widthDoc = (doc.internal.pageSize.width)
        let heightDoc = (doc.internal.pageSize.height)
        let heightDisponible=heightDoc
        let remision = idListaP.numCoti.replace('COT','REM');
        let logo = '', empresa='', nit='', direccion='', telefono='', empresaWeb='', cargoUsu='', mailUsu='', telefonoUsu=''
        let mail = idListaP.mailContacto?idListaP.mailContacto:''
        let ciudad = idListaP.ciudadContacto?idListaP.ciudadContacto:''
        let contacto = idListaP.nombreContacto?idListaP.nombreContacto:''
        let celular = idListaP.telContacto?idListaP.telContacto:''
        let ordenCompraCliente = idListaP.ordenCompraCliente?idListaP.ordenCompraCliente:''

        if(this.props.getParametro.getParametro){
          empresaWeb = this.props.getParametro.getParametro.empresaWeb
        }
        if(this.props.allEmpresaRtes.allEmpresaRtes){
          let argsBuscarEmp = {tipoqry: `[{$match: {'descrEmpresa': '${idListaP.descrEmpresa}'}}]`}
          let {data} = await this.props.allEmpresaRtes.refetch(argsBuscarEmp)
          empresa = data.allEmpresaRtes[0].descrEmpresa
          direccion = data.allEmpresaRtes[0].direccion
          telefono = data.allEmpresaRtes[0].telefono
        }
        if(this.props.allUsuariosRtes.allUsuariosRtes){
          let argsBuscarUsu = {tipoqry: `[{$match: {'nombreUsuario': '${idListaP.nombreUsuarioOC}'}}]`}
          let {data} = await this.props.allUsuariosRtes.refetch(argsBuscarUsu)
          cargoUsu = data.allUsuariosRtes[0].cargo
          mailUsu = data.allUsuariosRtes[0].email
          telefonoUsu = data.allUsuariosRtes[0].telefono
        }
        let dirEmpresa = 'images/logos/' + logo

            doc.setFillColor('#E9E4F0');
            doc.setDrawColor('black');
            // doc.lines([[(widthDoc)-20,0],[0,5],[0-(widthDoc)+20,0]], 12,35, [1,1], 'S', true)  
            doc.rect(12, 30, widthDoc-24, 55)   
            doc.line(12, 40, widthDoc-12, 40)    
            doc.line(12, 45, widthDoc-12, 45)    
            doc.line(12, 50, widthDoc-12, 50)    
            doc.line(12, 55, widthDoc-12, 55)    
            doc.line(12, 60, widthDoc-12, 60)    
            doc.line(12, 65, widthDoc-12, 65)    
            doc.line(12, 70, widthDoc-12, 70) 
            doc.line(12, 80, widthDoc-12, 80) 
            doc.line(37, 30, 37, 80)  
            doc.line(55, 30, 55, 40)
            doc.line(117, 30, 117, 65) 
            doc.line(136, 30, 136, 80) 
            doc.line(162, 30, 162, 40)
            doc.line(162, 70, 162, 80)
            doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,40.3, [1,1], 'F', true)
            doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,65.2, [1,1], 'F', true)
            doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,80.2, [1,1], 'F', true)

            doc.setFontSize(8);
            doc.setFontStyle('bold');
            doc.text(`FECHA DE `, 16, 34)
            // doc.text(`FECHA DE ELABORACION: `, 13, 34, {align: 'left',lineHeightFactor: 1,maxWidth:22})
            doc.text(`ELABORACION: `,13, 38)
            doc.text(fechaHoraHoy.substr(0, 10), 38, 37, 'left')
            doc.text(`FECHA DE ENTREGA: `, 70, 37, {align: 'left',lineHeightFactor: 1,maxWidth:30})
            doc.text(fechaHoraHoy.substr(0, 10), 119, 37, 'left')
            doc.text(`REMISION: `, 141, 37)
            doc.text(remision, 163, 37, 'left')
            doc.text(`INFORMACION DEL CLIENTE: `, 85, 44, {align: 'left',lineHeightFactor: 1,maxWidth:58})
            doc.text(`EMPRESA`, 16, 49)
            doc.text(empresa, 38, 49)
            doc.text(`TELEFONO`, 15.5, 54)
            doc.text(telefono, 38, 54)
            doc.text(`CIUDAD`, 18, 59)
            doc.text(ciudad, 38, 59)
            doc.text(`MAIL`, 20, 64)
            doc.text(mail, 38, 64)
            doc.text(`NIT`, 124, 49)
            doc.text(nit, 137, 49)
            doc.text(`DIRECCION`, 118.5, 54)
            doc.text(direccion, 137, 54)
            doc.text(`CONTACTO`, 118.5, 59)
            doc.text(contacto, 137, 59)
            doc.text(`CELULAR`, 119, 64)
            doc.text(celular, 137, 64)
            doc.text(`INFORMACION DE LA REMISION: `, 83, 69, {align: 'left',lineHeightFactor: 1,maxWidth:58})
            doc.text(`Descripción`, 16, 74)
            doc.text(`Orden de compra: `,12.5, 78)
            doc.text(`Código`, 143, 74)
            doc.text(`Orden de compra: `,137.5, 78)
            doc.text(ordenCompraCliente, 163, 76)

            doc.text(`DETALLE DE ORDEN DE COMPRA: `, 83, 84, {align: 'left',lineHeightFactor: 1,maxWidth:58})


            heightDisponible=heightDoc-80
            let posic = 90
            let lineasProd = 0
            let lineasUni = 0
            let tablaRte = []
            let argsUpd = []
            let numLineas = 0

            lista5.forEach((elemento1, iii) => {
              numLineas = lista5.length

              if(elemento1.descrProducto!=='Transporte' && elemento1.descrProducto!=='Transporte producto' && elemento1.descrProducto!=='Alojamiento, alimentación y transporte'){
                let parrafoProd = elemento1.descrProducto.split("\n")
                console.log(parrafoProd)
                let heightLineaItem=0
                let parrafoUni = elemento1.descrUnidad.split("\n")
        
                parrafoProd.forEach((textoProd, ii) => {   
                  lineasProd = doc.splitTextToSize(textoProd, 148)
                  lineasUni = doc.splitTextToSize(parrafoUni, 14)
                  console.log(textoProd, lineasProd)
                  console.log(parrafoUni, lineasUni)
                  if(textoProd){
                    if(lineasProd.length===1){
                      if(lineasUni.length===1){
                        posic+=5
                        heightLineaItem=5
                      }else{
                        posic+=5*lineasUni.length
                        heightLineaItem=(5*lineasUni.length)
                      }            
                    }else{
                      posic+=5*lineasProd.length
                      heightLineaItem=(5*lineasProd.length)
                    }
                    if(heightLineaItem>heightDisponible){
                      posic=35
                      heightDisponible=heightDoc-25
                    }
                    if(lineasProd.length===1){
                      if(lineasUni.length===1){
                        heightDisponible=heightDisponible-5
                      }else{
                        heightDisponible=heightDisponible-(5*lineasUni.length)
                      }            
                    }else{
                      heightDisponible=heightDisponible-(5*lineasProd.length)
                    }
                  }
                })

                argsUpd.push(iii+1)
                argsUpd.push(elemento1.descrProducto)
                argsUpd.push(elemento1.cantidadAprob)
                argsUpd.push(elemento1.descrUnidad)
                argsUpd.push('')
                argsUpd.push('')
                tablaRte.push(argsUpd) 
                argsUpd = []
              }
            })
            

            let indice = 0
            let esComp = false
            doc.autoTable({
              startY: 85,
              rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
              showHead: 'everyPage',
              tableLineColor: "black",
              tableLineWidth: 0.1,
              styles: {
                fontSize: 6,
                lineColor: "black",
                lineWidth: 0.1,
                valign: "top",
              },
              headStyles: {
                fillColor: "#E9E4F0",
                textColor: "black",
                halign: "center",
                valign: "top",
                cellPadding: 1,
                fontStyle: "bold",
                fontSize: 6
              },
              bodyStyles: {
                // fillColor: "#E9E4F0",
                fillColor: "white",
                textColor: "black",
                halign: "center",
                minCellHeight: 1
              },
              columnStyles: {
                0: {cellWidth: 10},
                1: {cellWidth: 105.7},
                2: {cellWidth: 13},
                3: {cellWidth: 13},
                4: {cellWidth: 20},
                5: {cellWidth: 28},
              },

              didParseCell(data) {
                if(data.row.index !== -1 && data.section==='body'){
                  data.cell.styles.minCellHeight = 1
                  data.cell.styles.fillColor = "white"
                  data.cell.styles.fontStyle = "normal"
                }
              },

              didDrawCell: (data) => {
                //imagenes en autoTable
                //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
  if(data.row.index===-1){
  console.log("ojoooo")
  }
              },
              alternateRowStyles: {
                // fillColor: "white",
                textColor: "black"
              },
              head: [["ITEM", "DESCRIPCION", "CANTIDAD", "UNIDAD", "RECIBIDO POR", "OBSERVACION"]],
              body: tablaRte,
              margin: {top: 100, left: 12, right: 12, bottom: 25}
            })

            // doc.setFillColor('#E9E4F0');
            // doc.lines([[(widthDoc/2)-20,0],[0,5],[0-(widthDoc/2)+20,0]], 12,150, [1,1], 'F', true)
            // doc.lines([[(widthDoc/2)-20,0],[0,5],[0-(widthDoc/2)+20,0]], (widthDoc/2),150, [1,1], 'F', true)
            // doc.setFillColor('#bdc3c7');

            posic+=10
            heightDisponible=heightDoc-25-posic
            
            if(heightDisponible<35){
              posic=30
              heightDisponible=heightDoc-25
              doc.addPage()
            }
            doc.setDrawColor('black');
            doc.rect(12, posic, widthDoc-24, 5)
            doc.text(`OBSERVACIONES`, 95, posic+4, 'left')
            doc.rect(12, posic+5, widthDoc-24, 30)
            posic+=35
            heightDisponible=heightDoc-25-posic

            if(heightDisponible<50){
              posic=30
              heightDisponible=heightDoc-25
              doc.addPage()
            }
            doc.rect(12, posic, widthDoc-24, 5)   
            doc.text(`INFORMACION DE ACTA DE ENTREGA`, 85, posic+4, 'left')

            tablaRte = []
            argsUpd = []

            argsUpd.push('FIRMA');
            argsUpd.push('FIRMA');
            tablaRte.push(argsUpd) 
            argsUpd = []
            argsUpd.push('');
            argsUpd.push('');
            tablaRte.push(argsUpd) 
            argsUpd = []
            argsUpd.push('');
            argsUpd.push('');
            tablaRte.push(argsUpd) 
            argsUpd = []
            argsUpd.push('');
            argsUpd.push('');
            tablaRte.push(argsUpd) 
            argsUpd = []  
            argsUpd.push('Nombre: ' + idListaP.nombreUsuario);
            argsUpd.push('Nombre: ');
            tablaRte.push(argsUpd) 
            argsUpd = []
            argsUpd.push('Cargo: ' + cargoUsu);
            argsUpd.push('Cargo: ');
            tablaRte.push(argsUpd) 
            argsUpd = []
            argsUpd.push('email: ' + mailUsu);
            argsUpd.push('email: ');
            tablaRte.push(argsUpd) 
            argsUpd = []
            argsUpd.push('Teléfono: ' + telefonoUsu);
            argsUpd.push('Teléfono: ');
            tablaRte.push(argsUpd) 
            argsUpd = []

            
            doc.autoTable({
              startY: posic+5,
              rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
              showHead: 'everyPage',
              tableLineColor: "black",
              tableLineWidth: 0.1,
              styles: {
                fontSize: 6,
                lineColor: "black",
                lineWidth: 0.1,
                valign: "top",
              },
              headStyles: {
                fillColor: "#E9E4F0",
                textColor: "black",
                halign: "center",
                valign: "top",
                cellPadding: 1,
                fontStyle: "bold",
                fontSize: 6
              },
              bodyStyles: {
                // fillColor: "#E9E4F0",
                fillColor: "white",
                textColor: "black",
                halign: "left",
                minCellHeight: 1
              },
              columnStyles: {
                0: {cellWidth: 95.6},
                1: {cellWidth: 95.6},
              },

              didParseCell(data) {
                if(data.row.index !== -1 && data.section==='body'){
                  data.cell.styles.minCellHeight = 1
                  data.cell.styles.fillColor = "white"
                  data.cell.styles.fontStyle = "normal"
                }
                if(data.row.index === 0 && data.section==='body'){
                  if(data.column.index === 0 || data.column.index === 1){
                    data.cell.rowSpan = 4
                    data.cell.styles.halign = 'center'
                    data.cell.styles.valign = 'bottom'
                  }
                }
                if(data.row.index !== -1 && data.section==='body' && data.column.index === 1){
      
                }
              },

              didDrawCell: (data) => {
                //imagenes en autoTable
                //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
  if(data.row.index===-1){
  console.log("ojoooo")
  }
              },
              alternateRowStyles: {
                textColor: "black"
              },
              head: [["CONTRATISTA", "CONTRATANTE"]],
              body: tablaRte,
              margin: {top: 100, left: 12, right: 12, bottom: 25}
            })




          const pageCount = doc.internal.getNumberOfPages();
          // For each page, print the page number and the total pages
          for(var i = 1; i <= pageCount; i++) {
                // Go to page i
              doc.setPage(i);

  //ENCABEZADO DE PAGINA
              doc.setFontSize(10);
              doc.setTextColor('black');
              doc.setFontType("bold");
              doc.text(idListaP.descrEmpresa, widthDoc/2, 14, 'center')
              doc.text("REMISION No. " + remision, widthDoc/2, 20, 'center')
              doc.setFontSize(8);

              let dirSlcm = 'images/logos/LCMSAS.png'
              let logo = ""
              let imgSource = new Image();
              try{
                imgSource.src = dirSlcm;
                doc.convertStringToImageData(imgSource)
                doc.addImage(imgSource, 'PNG', 12, 12, 55, 17);
              }catch{
                console.log("Logo de LCM no existe")
              }
  //FIN ENCABEZADO DE PAGINA

  //PIE DE PAGINA

              doc.setFontSize(8);
              doc.setTextColor(255,0,0);
              doc.setFontStyle('Watermark');
              doc.text(empresaWeb, widthDoc/2, heightDoc-15, 'center')
              doc.text("Colombia - Ecuador - Panamá", widthDoc/2, heightDoc-12, 'center')

              doc.text('Pag ' + String(i) + ' de ' + String(pageCount), 12, heightDoc-12, 'left')
              doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
              // doc.text('Pag ' + String(i) + ' de ' + String(pageCount),210-20,297-30,null,null,"left");
          }
        let nameDoc = `REMISION_${remision}_${idListaP.descrEmpresa}.pdf`
        doc.save(nameDoc)
      }else{
        alert("!! La remisión solo se genera para órdenes de compra de productos !!")
      }
      document.body.style.cursor = 'default'
    }
    
    //FIN Exportar a Pdf
    this.setState({permiteBtn1: true, permiteBtn2: true, open: false, confirmaAct: false})
  }


  handleBuscCad = async (argsBuscCad) => {
    let argsBuscar={}

    if(argsBuscCad.numDocum){
      argsBuscar.numDocum=parseInt(argsBuscCad.numDocum, 10)
    }
    // else{
    //   argsBuscar.numDocum=100
    // }
    if(argsBuscCad.pais){
      argsBuscar.pais=argsBuscCad.pais
    }else{
      delete argsBuscar.pais
    }
    if(argsBuscCad.descrEmpresa){
      argsBuscar.descrEmpresa=argsBuscCad.descrEmpresa
    }else{
      delete argsBuscar.descrEmpresa
    }
    if(argsBuscCad.numCoti){
      argsBuscar.numCoti=argsBuscCad.numCoti
    }else{
      delete argsBuscar.numCoti
    }
    if(argsBuscCad.numFactura){
      argsBuscar.numFactura=argsBuscCad.numFactura
    }else{
      delete argsBuscar.numFactura
    }
    if(argsBuscCad.numOrdenCompra){
      argsBuscar.numOrdenCompra=parseInt(argsBuscCad.numOrdenCompra, 10)
    }else{
      delete argsBuscar.numOrdenCompra
    }
    if(argsBuscCad.ordenCompraCliente){
      argsBuscar.ordenCompraCliente=argsBuscCad.ordenCompraCliente
    }else{
      delete argsBuscar.ordenCompraCliente
    }    
    if(argsBuscCad.nombreUsuario){
      argsBuscar.nombreUsuario=argsBuscCad.nombreUsuario
    }else{
      delete argsBuscar.nombreUsuario
    }
    if(argsBuscCad.nombreUsuarioOC){
      argsBuscar.nombreUsuarioOC=argsBuscCad.nombreUsuarioOC
    }else{
      delete argsBuscar.nombreUsuarioOC
    }
    if(argsBuscCad.estadoCoti){
      argsBuscar.estadoCoti=argsBuscCad.estadoCoti
    }else{
      delete argsBuscar.estadoCoti
    }
    if(argsBuscCad.estadoOC){
      argsBuscar.estadoOC=argsBuscCad.estadoOC
    }else{
      delete argsBuscar.estadoOC
    }
    if(argsBuscCad.totalOC){
      argsBuscar.totalOC=argsBuscCad.totalOC
    }else{
      delete argsBuscar.totalOC
    }
    console.log(argsBuscar)
    this.setState({argsBuscCad: argsBuscar});
    console.log(this.state.argsBuscCad)

    //VALIDAR SI MODIFICARON EL localStorage userLogin o Empresa
    const argsEncr = {
      valor: localStorage.getItem('userLogin'),
      comparar: localStorage.getItem('token1')
    }
    const response = await this.props.encriptar({
      variables: argsEncr
    });
    const {success} = response.data.encriptar;
    let enapp = success
    if(enapp){
      const argsEncr = {
        valor: localStorage.getItem('Empresa'),
        comparar: localStorage.getItem('token2')
      }
      const response = await this.props.encriptar({
        variables: argsEncr
      });
      const {success} = response.data.encriptar;
      enapp = success  
    }
    if (!enapp){
//MODIFICARON EL localStorage userLogin o Empresa
      localStorage.removeItem('token');
      localStorage.removeItem('token1');
      localStorage.removeItem('token2');
      localStorage.removeItem('Empresa');
      localStorage.removeItem('userLogin');
console.log("ojo")
      this.props.history.push("/")
    }
  }


  crudBD = async (operacionCRUD, args)=>{
//ACTUALIZAR BD
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
//ENVIO PARA ACTUALIZAR BD
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0])
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0])
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i])
    }
  }

  idLista = async (ev, idLista)=>{
    this.setState({idLista: idLista})
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showPolitica) {
      this.setState({verPolitica: true})
    }
    if (this.state.showCotizacion) {
      this.setState({verCotizacion: true})
      let argsBuscar=""
      argsBuscar += `'numCoti': '${idLista.numCoti}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
      this.setState({lista4: await data.allCotizacionRtes})
      this.setState({tipoC: idLista.tipo})
    }
    if (this.state.showTraslado) {
      this.setState({verTraslado: true})
      let argsBuscar=""
      argsBuscar += `'numCoti': '${idLista.numCoti}'`
      let argsBuscarIt = {}
      console.log(argsBuscarIt)
      argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery9}]`}
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
      this.setState({lista4: await data.allCotizacionRtes})
      this.setState({tipoC: idLista.tipo})
    }
    if (this.state.envCotizacion) {
      let argsBuscar=""
      argsBuscar += `'numCoti': '${idLista.numCoti}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
      if(data.allCotizacionRtes){
        this.setState({lista4: await data.allCotizacionRtes})
        console.log(this.state.lista4)
      }
    }
    if (this.state.showOrdenCompra) {
      this.setState({verOrdenCompra: true})
      let argsBuscar=""
      argsBuscar += `numOrdenCompra: '${idLista.numOrdenCompra}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionRtes00.refetch(argsBuscarIt)
      let registros = await data.allCotizacionRtes
      this.setState({lista5: registros})
    }
    if (this.state.showOrdenCompraFin) {
      this.setState({verOrdenCompraFin: true})
      let argsBuscar=""
      let registros = [], registros2 = []
      argsBuscar += `numOrdenCompra: '${idLista.numOrdenCompra}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[${this.state.argsQuery2}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
      this.setState({lista6: await data.allCotizacionRtes})
      if(2>1){
        argsBuscarIt = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
        let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
        registros = await data.allCotizacionRtes
      }
      if(2>1){
        let argsBuscar=`numOrdenCompra: ${idLista.numOrdenCompra}`
        let argsBuscar2=`despFact: 'D'`
        let argsBuscarIt = {}
        argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery8}, {$match: {${argsBuscar2}}}]`}
        console.log(argsBuscarIt)
        let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
        registros2 = await data.allCotizacionRtes
      }    
      this.setState({lista5: registros, lista7: registros2})
    }
    if (this.state.showTrasladoFin) {
      this.setState({verTrasladoFin: true})
      let argsBuscar=""
      let registros = [], registros2 = []
      argsBuscar += `numCoti: '${idLista.numCoti}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery9}]`}
      console.log(argsBuscarIt)
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
      this.setState({lista6: await data.allCotizacionRtes})
      if(2>1){
        argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery9}]`}
        console.log(argsBuscarIt)
        let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
        registros = await data.allCotizacionRtes
      }
      if(2>1){
        let argsBuscar=`numCoti: '${idLista.numCoti}'`
        let argsBuscar2=`despFact: 'D'`
        let argsBuscarIt = {}
        argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery10}, {$match: {${argsBuscar2}}}]`}
        console.log(argsBuscarIt)
        let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
        registros2 = await data.allCotizacionRtes
      }    
      this.setState({lista5: registros, lista7: registros2})
    }
    if (this.state.showEncuesta) {
      this.setState({verEncuesta: true})
      let argsBuscar=""
      argsBuscar += `numOrdenCompra: '${idLista.numOrdenCompra}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[${this.state.argsQuery2}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionRtes00.refetch(argsBuscarIt)
      this.setState({lista6: await data.allCotizacionRtes})
    }
    if (this.state.showFacturacion) {
      this.setState({verFacturacion: true})
      let argsBuscar=`numOrdenCompra: ${idLista.numOrdenCompra}`
      let argsBuscar2=`despFact: 'F', codAvance: '${idLista.numAvance}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery7}, {$match: {${argsBuscar2}}}]`}
      let {data} = await this.props.allCotizacionRtesFac1.refetch(argsBuscarIt)
      let registros = await data.allCotizacionRtes
      this.setState({lista5: registros})
    }
    // if (this.state.showPagosCli) {
    //   this.setState({verPagosCli: true})
    //   let argsBuscar=`numOrdenCompra: ${idLista.numOrdenCompra}`
    //   let argsBuscar2=`despFact: 'F', codAvance: '${idLista.numAvance}'`
    //   let argsBuscarIt = {}
    //   argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery7}, {$match: {${argsBuscar2}}}]`}
    //   let {data} = await this.props.allCotizacionRtesPagos.refetch(argsBuscarIt)
    //   let registros = await data.allCotizacionRtes
    //   this.setState({lista5: registros})
    // }
    if (this.state.showRegPago) {
      console.log(idLista)
      this.setState({verRegPago: true})
      let argsBuscar=""
      argsBuscar += `numOrdenCompra: ${idLista.numOrdenCompra}`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery4}]`}
      console.log(argsBuscarIt)
      let {data} = await this.props.allCotizacionRtes000.refetch(argsBuscarIt)
      let registros = await data.allCotizacionRtes
      this.setState({lista55: registros})
      console.log(this.state.lista55)
    }
    if (this.state.showCadena) {
    }
    if (this.state.showCotizacionPro) {
      console.log(idLista)
      this.setState({verCotizacionPro: true})
      let argsBuscar=""
      argsBuscar += `'numCoti': '${idLista.numCoti}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
      console.log(argsBuscarIt)
      let {data} = await this.props.allCotizacionProRtes1.refetch(argsBuscarIt)
      console.log(data.allCotizacionRtes)
      if(data.allCotizacionRtes && data.allCotizacionRtes.length>0){
        this.setState({lista4: await data.allCotizacionRtes})
      }
    }
    if (this.state.showCotizacionProve) {
      this.setState({verCotizacionProve: true})
    }
    if (this.state.showOrdenCompraPro) {
      let argsBuscar=""
      argsBuscar += `'numCoti': '${idLista.numCoti}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[${this.state.argsQuery3}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt)
      this.setState({lista4: await data.allCotizacionRtes})
      console.log(this.state.lista4)
    }
  };
  
  idListaI = async (ev, idLista)=>{
    this.setState({productoI: idLista.descrProducto})
    ev.preventDefault()
  };
  idListaE = async (ev, idLista)=>{
    this.setState({preguntaE: idLista.pregunta, respuestaE: idLista.respuesta})
    ev.preventDefault()
  };
  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: true, permiteDelete: false})
  }

  handleClickDel = async (ev) => {
    ev.preventDefault()
    this.setState({
      permiteUpdate: false,
      permiteDelete: true,
    })
  }
  handleClickItem = async (ev) => {
    ev.preventDefault()
    this.setState({
      permiteUpdate: false,
      permiteDelete: false,
      addItemCoti: true,
    })
  }
  handleClickItemT = async (ev) => {
    ev.preventDefault()
    this.setState({
      permiteUpdate: false,
      permiteDelete: false,
      addItemTras: true,
    })
  }
  handleClickItemPro = async (ev) => {
    ev.preventDefault()
    this.setState({
      permiteUpdate: false,
      permiteDelete: false,
      addItemCotiPro: true,
    })
  }
  handleClickItemOC = async (ev) => {
    ev.preventDefault()
    this.setState({
      permiteUpdate: false,
      permiteDelete: false,
      addItemOC: true,
    })
  }
  handleClickItemEnc = async (ev) => {
    ev.preventDefault()
    this.setState({
      permiteUpdate: false,
      permiteDelete: false,
      addItemEnc: true,
    })
  }
  componentDidUpdate(prevProps){

  }

  render(){
    const {showAdmin, 
      showPolitica, addPolitica, verPolitica, showAsDocCoti, adminPrecios, 
      verCotizacion, showCotizacion, addCotizacion, addItemCoti, envCotizacion, 
      showTraslado, addTraslado, verTraslado, addItemTras, showTrasladoFin, verTrasladoFin, 
      verOrdenCompra, showOrdenCompra, addOrdenCompra, addItemOC, argsBuscar, argsBuscEmp, argsBuscCoti,
      verOrdenCompraFin, showOrdenCompraFin, addItemEnc, verEncuesta, showEncuesta, 
      showFacturacion, showFacturacionLog, showRecaudoLog, verFacturacion, showPagosCli, showPagosCli2, verPagosCli, showRegPago, verRegPago, showCadena, argsBuscCad,
      verCotizacionPro, showCotizacionPro, addCotizacionPro, addItemCotiPro, showInd,
      verCotizacionProve, showCotizacionProve, addCotizacionProve, showCotizacionSelecc, showOrdenCompraPro,
      permiteUpdate, permiteDelete, argsAdd, errorAdd, idLista, errors} = this.state;        

    let lista = []
    let lista1 = []
    let lista2 = []
    let lista3 = []
    let listaE = []
    let lista22 = []
    let listaItem = []
    let lista11 = []
    const a354007 = this.props.autorizacUA.findIndex( autorizac => autorizac === "354007" );
    console.log(this.props.allCotizacionRtesPagos22.allCotizacionRtes)

    if (this.state.showPolitica) {
      if(this.props.allPolitica.allPolitica){lista = this.props.allPolitica.allPolitica}
    }
    if (this.state.showCotizacion) {
      if(this.props.allCotizacionRtesCot.allCotizacionRtes){
        lista = this.props.allCotizacionRtesCot.allCotizacionRtes
      }
    }
    if (this.state.showTraslado) {
      if(this.props.allCotizacionRtesTras.allCotizacionRtes){
        lista = this.props.allCotizacionRtesTras.allCotizacionRtes
      }
    }
    if (this.state.envCotizacion) {
    }
    if (this.state.addCotizacion || this.state.verCotizacion) {
      if(this.props.allEmpresa.allEmpresa){lista = this.props.allEmpresa.allEmpresa}
      if(this.props.allPolitica.allPolitica){lista1 = this.props.allPolitica.allPolitica}
      if(this.props.allUsuariosRtes1.allUsuariosRtes){lista2 = this.props.allUsuariosRtes1.allUsuariosRtes}
      if(this.props.allUsuariosRtes2.allUsuariosRtes){lista3 = this.props.allUsuariosRtes2.allUsuariosRtes}
    }
    if (this.state.addItemCoti || this.state.addItemTras || this.state.adminPrecios) {
      if(this.props.allProducto.allProducto){listaItem = this.props.allProducto.allProducto}
      if(this.props.allUnidad.allUnidad){lista11 = this.props.allUnidad.allUnidad}
    }
    if (this.state.addTraslado || this.state.verTraslado) {
      if(this.props.allEmpresa.allEmpresa){lista = this.props.allEmpresa.allEmpresa}
      if(this.props.allUsuariosRtes1.allUsuariosRtes){lista2 = this.props.allUsuariosRtes1.allUsuariosRtes}
    }
    if (this.state.addItemTras) {
      if(this.props.allProducto.allProducto){listaItem = this.props.allProducto.allProducto}
      if(this.props.allUnidad.allUnidad){lista11 = this.props.allUnidad.allUnidad}
    }
    if (this.state.showAsDocCoti) {
      if(this.props.allCotizacionRtesAsoc.allCotizacionRtes){lista = this.props.allCotizacionRtesAsoc.allCotizacionRtes}
    }
    if (this.state.showOrdenCompra) {
    }
    if (this.state.showOrdenCompraFin) {
    }
    if (this.state.verOrdenCompraFin) {
      if(this.props.allUsuariosRtes.allUsuariosRtes){lista1 = this.props.allUsuariosRtes.allUsuariosRtes}
      console.log(lista1)
    }
    if (this.state.addOrdenCompra || this.state.verOrdenCompra) {
      if(this.props.allEmpresa.allEmpresa){lista = this.props.allEmpresa.allEmpresa}
      if(this.props.allUsuariosRtes.allUsuariosRtes){lista1 = this.props.allUsuariosRtes.allUsuariosRtes}
      const elemento3 = this.props.allPerfiles.allPerfiles
      elemento3.forEach((elemento, i) => {
        let autorizacPer = elemento.autorizac.map((elemento, _id) => elemento.codigoAutorizac)
        let indexAut = autorizacPer.findIndex( autorizac => autorizac==='3545')
        if(indexAut!==-1){
          lista2.push({descrPerfil: elemento.descrPerfil});
        }
      })
    }
    if (this.state.addItemOC) {
      if(this.props.allProducto.allProducto){lista = this.props.allProducto.allProducto}
    }
    if (this.state.showEncuesta) {
      if(this.props.allCotizacionRtes33.allCotizacionRtes){lista = this.props.allCotizacionRtes33.allCotizacionRtes}
    }
    if (this.state.showCadena) {
      // if(this.props.allCotizacionRtesCad.allCotizacionRtes){lista = this.props.allCotizacionRtesCad.allCotizacionRtes}
    }
    if (this.state.showFacturacion) {
      if(this.props.allCotizacionRtesFac.allCotizacionRtes){lista = this.props.allCotizacionRtesFac.allCotizacionRtes}
    }
    if (this.state.showFacturacionLog) {
      // if(this.props.allCotizacionRtesFacLog.allCotizacionRtes){lista = this.props.allCotizacionRtesFacLog.allCotizacionRtes}
    }
    if (this.state.showPagosCli2) {
      if(this.props.allCotizacionRtesPagos22.allCotizacionRtes){
        console.log(this.props.allCotizacionRtesPagos22.allCotizacionRtes)
        lista = this.props.allCotizacionRtesPagos22.allCotizacionRtes
        console.log(lista)
      }else{
        console.log(lista)
      }
    }
    if (this.state.showRegPago) {
      if(this.props.allCotizacionRtes444.allCotizacionRtes){lista = this.props.allCotizacionRtes444.allCotizacionRtes}
    }
    if (this.state.showCotizacionPro) {
      if(this.props.allCotizacionProRtes.allCotizacionRtes){lista = this.props.allCotizacionProRtes.allCotizacionRtes}
    }
    if (this.state.addItemCotiPro) {
      if(this.props.allMaterial.allMaterial){lista = this.props.allMaterial.allMaterial}
    }
    if (this.state.addCotizacionProve) {
      this.props.allCotizacionProRtes3.refetch()
      if(this.props.allCotizacionProRtes3.allCotizacionRtes){lista3 = this.props.allCotizacionProRtes3.allCotizacionRtes}
      console.log(lista3)
      if(this.props.allMaterial.allMaterial){lista = this.props.allMaterial.allMaterial}
      if(this.props.allUnidad.allUnidad){lista1 = this.props.allUnidad.allUnidad}
      if(this.props.allProveed.allProveed){lista2 = this.props.allProveed.allProveed}
    }

    if (this.state.showCotizacionProve) {
    }
    if (this.state.showCotizacionSelecc) {
      if(this.props.allCotizacionProRtes3.allCotizacionRtes){lista = this.props.allCotizacionProRtes3.allCotizacionRtes}
    } 
    if (this.state.showOrdenCompraPro) {
    }
    let fechaHoy = new Date()
    fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    //calcular fechaHoy como 364 dias antes de la fecha actual
    let fechaFin = parseInt((new Date().getTime() + (1000*60*60*24)*15), 10)
    fechaFin = new Date(fechaFin)
    fechaFin = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())
    let trmHoy = 0
    if(this.props.getParametro.getParametro){
      trmHoy = this.props.getParametro.getParametro.trm
      // trmHoy=trmHoy.replace(",", ".")
    }

    return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showAdmin && <HomeAdmin1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                          // handleClickSel11={this.showMetaCial} 
                          handleClickSel11={this.showTraslado} 
                          handleClickSel13={this.adminPrecios} 
                          handleClickSel12={this.showTrasladoFin}
                          handleClickSel15={this.showCotizacion} handleClickSel16={this.envCotizacion}
                          handleClickSel17={this.showAsDocCoti} handleClickSel18={this.showOrdenCompra}
                          handleClickSel19={this.showOrdenCompraFin} handleClickSel20={this.showFacturacion}
                          handleClickSel21={this.showCadena} handleClickSel22={this.showEncuesta}
                          handleClickSel23={this.showCotizacionPro} handleClickSel24={this.showCotizacionProve}
                          handleClickSel25={this.showOrdenCompraPro} 
                          handleClickSel28={this.showCotizacionSelecc} handleClickSel29={this.showRegPago}
                          handleClickSel30={this.showFacturacionLog} handleClickSel14={this.showRecaudoLog}
                          handleClickSel31={this.showInd} handleClickSel32={this.showPagosCli2}/>}

            {showPolitica && <AdminPolitica1 styles={this.props.styles} handleClickRegr={this.showAdmin}/>}
            {addPolitica && <AddPolitica1 styles={this.props.styles} handleClickRegr={this.showPolitica}/>}
            {verPolitica && <VerPolitica1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showPolitica} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}
            {adminPrecios && <AdminPrecios1 styles={this.props.styles} handleClickRegr={this.showAdmin}/>}
            {showCotizacion && <AdminCotizacion1 styles={this.props.styles} handleClickRegr={this.showAdmin}
                handleChange={this.handleChangeBuscCad} handleSubmit={this.handleBuscCad}
                args={argsBuscar}/>}
            {addCotizacion && <AddCotizacion1 styles={this.props.styles} handleClickRegr={this.showCotizacion}/>}
            {verCotizacion && <VerCotizacion1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showCotizacion} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel} handleClickItem={this.handleClickItem}/>}
            {showAsDocCoti && <AsocDocCoti1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                handleChange={this.handleChangeBuscCad} handleSubmit={this.handleBuscCad}
                args={argsBuscar} handleClickRegr={this.showAdmin}/>}
            {envCotizacion && <AdminEnvCoti1 styles={this.props.styles} handleClickRegr={this.showAdmin}
                handleChange={this.handleChangeBuscCad} handleSubmit={this.handleBuscCad}
                args={argsBuscar}/>}
            {showOrdenCompra && <AdminOrdenCompra1 styles={this.props.styles} handleClickRegr={this.showAdmin}
                handleChange={this.handleChangeBuscCad} handleSubmit={this.handleBuscCad}
                args={argsBuscar}/>}

            {addOrdenCompra && <AddOrdenCompra1 styles={this.props.styles} handleClickRegr={this.showOrdenCompra}/>}
            {verOrdenCompra && <VerOrdenCompra1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showOrdenCompra} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel} handleClickItemOC={this.handleClickItemOC}/>}
            {showOrdenCompraFin && <AdminOrdenCompraFin1 styles={this.props.styles} handleClickRegr={this.showAdmin}
                handleChange={this.handleChangeBuscCad} handleSubmit={this.handleBuscCad}
                args={argsBuscar}/>}
            {verOrdenCompraFin && <VerOrdenCompraFin1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showOrdenCompraFin} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}
            {showEncuesta && <AdminEncuesta1 styles={this.props.styles} handleClickRegr={this.showAdmin}/>}
            {verEncuesta && <VerEncuesta1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showEncuesta} handleClickUpd={this.handleClickUpd}/>}
            {showFacturacion && <AdminFacturacion1 styles={this.props.styles} handleClickRegr={this.showAdmin}
                handleChange={this.handleChangeBuscCad} handleSubmit={this.handleBuscCad}
                args={argsBuscar}/>}
            {showFacturacionLog && <AdminFacturacionLog1 styles={this.props.styles} handleClickRegr={this.showAdmin}
                handleChange={this.handleChangeBuscCad} handleSubmit={this.handleBuscCad}
                args={argsBuscar}/>}
            {verFacturacion && <VerFacturacion1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showFacturacion} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel} />}
            {/* {showPagosCli && <AdminPagosCli1 styles={this.props.styles} handleClickRegr={this.showAdmin}
                handleChange={this.handleChangeBuscCad} handleSubmit={this.handleBuscCad}
                args={argsBuscar}/>} */}
            {showPagosCli2 && <AdminPagosCli21 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showAdmin}
                handleSubmit={this.handleBuscCad} args={argsBuscar} handleChange={this.handleChangeBuscCad}/>}
            {showRecaudoLog && <AdminRecaudoLog1 styles={this.props.styles} handleClickRegr={this.showAdmin}
                handleChange={this.handleChangeBuscCad} handleSubmit={this.handleBuscCad}
                args={argsBuscar}/>}
            {showCadena && <AdminCadena1 styles={this.props.styles} handleClickRegr={this.showAdmin}
                handleChange={this.handleChangeBuscCad} handleSubmit={this.handleBuscCad}
                args={argsBuscar}/>}
            {showInd && <AdminInd1 styles={this.props.styles} handleClickRegr={this.showAdmin}/>}
            {showTraslado && <AdminTraslado1 styles={this.props.styles} handleClickRegr={this.showAdmin}
                handleChange={this.handleChangeBuscCad} handleSubmit={this.handleBuscCad}
                args={argsBuscar}/>}
            {addTraslado && <AddTraslado1 styles={this.props.styles} handleClickRegr={this.showTraslado}/>}
            {verTraslado && <VerTraslado1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showTraslado} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel} handleClickItemT={this.handleClickItemT}/>}
            {showTrasladoFin && <AdminTrasladoFin1 styles={this.props.styles} handleClickRegr={this.showAdmin}
                handleChange={this.handleChangeBuscCad} handleSubmit={this.handleBuscCad}
                args={argsBuscar}/>}
            {verTrasladoFin && <VerTrasladoFin1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showTrasladoFin} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}
            {showCotizacionPro && <AdminCotizacionPro1 styles={this.props.styles} handleClickRegr={this.showAdmin}/>}
            {addCotizacionPro && <AddCotizacionPro1 styles={this.props.styles} handleClickRegr={this.showCotizacionPro}/>}
            {verCotizacionPro && <VerCotizacionPro1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showCotizacionPro} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel} handleClickItem={this.handleClickItemPro}/>}
            {showCotizacionProve && <AdminCotizacionProve1 styles={this.props.styles} handleClickRegr={this.showAdmin}/>}
            {addCotizacionProve && <AddCotizacionProve1 styles={this.props.styles} handleClickRegr={this.showCotizacionProve}/>}
            {verCotizacionProve && <VerCotizacionProve1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showCotizacionProve} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}
            {showCotizacionSelecc && <AdminCotizacionSelecc1 styles={this.props.styles} handleClickRegr={this.showAdmin}/>}
            {showOrdenCompraPro && <AdminOrdenCompraPro1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                handleClickRegr={this.showAdmin}/>}
            {showRegPago && <AdminRegPago1 styles={this.props.styles} handleClickRegr={this.showAdmin}/>}
            {verRegPago && <VerRegPago1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showRegPago} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel} />}
          </div>
         
          <div className="column" style={this.props.styles.boxDer}>
            {showAdmin && <HomeAdmin2 styles={this.props.styles}/>}

            {showPolitica && <AdminPolitica2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addPolitica} list={lista} handleClickidLista={this.idLista}/>}
            {addPolitica && <AddPolitica2 styles={this.props.styles} handleLista={this.handleSelTipoPolitica} 
                handleSubmit={this.handlePolitica} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verPolitica && <VerPolitica2 styles={this.props.styles} handleSubmit={this.handlePolitica} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}
            {adminPrecios && <AdminPrecios2 styles={this.props.styles} listItem={listaItem} listUni={lista11} 
                errors={errorAdd} />}
            {showCotizacion && <AdminCotizacion2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addCotizacion} list={lista} 
                handleClickidLista={this.idLista} argsBuscCad={argsBuscCad}/>}
            {addCotizacion && <AddCotizacion2 styles={this.props.styles} handleLista={this.handleSelDescrEmpresa} 
                handleLista1={this.handleSelDescrPolitica} handleLista2={this.handleSelDescrContacto} handleLista3={this.handleSelnombreUsuario} 
                handleLista4={this.handleSelEntrega} handleLista5={this.handleSelPago} handleLista6={this.handleSelOferta}
                handleLista55={this.handleSelMoneda2} handleLista77={this.handleSelImpto}
                handleLista8={this.handleSelMoneda2} handleLista9={this.handleSelImpto}
                handleSubmit={this.handleCotizacion} list={lista} list1={lista1} handleLista10={(ev, nameLista)=>this.handleSelSiNo(ev, nameLista)}
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verCotizacion && <VerCotizacion2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleSubmit={this.handleCotizacion} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                list4={this.state.lista4} addItem={this.state.addItem} list={lista} list1={lista1} list2={lista2} list3={lista3}
                permiteDelete={permiteDelete}/>}
            {addItemCoti && <AddItemCoti2 styles={this.props.styles} handleLista={this.handleSelDescrProducto} 
                handleLista1={this.handleSelDescrUnidad} 
                handleSubmit={this.handleItemCoti} tipoC={this.state.tipoC} listItem={listaItem} listUni={lista11} idLista={idLista}
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {showAsDocCoti && <AsocDocCoti2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                  handleUpdAsDocCoti={this.handleUpdAsDocCoti} errors={errorAdd}
                  handleElimAsDocCoti={this.handleElimAsDocCoti} argsBuscCad={argsBuscCad}
                  handleChange={this.handleChangeBuscCoti} fechaHoy={fechaHoy}/>} 
            {envCotizacion && <AdminEnvCoti2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addCotizacion} list4={this.state.lista4} 
                handleUpdAsDocCoti={this.handleUpdAsDocCoti} handleElimAsDocCoti={this.handleElimAsDocCoti} 
                handleClickidLista={this.idLista} argsBuscCad={argsBuscCad}/>}
            {showOrdenCompra && <AdminOrdenCompra2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addOrdenCompra} handleClickidLista={this.idLista} 
                // list={lista} 
                nomUsuarioUA={this.props.nomUsuarioUA} argsBuscCad={argsBuscCad}/>}
            {addOrdenCompra && <AddOrdenCompra2 styles={this.props.styles} handleLista={this.handleSelDescrEmpresaOC} 
                handleLista1={this.handleSelnombreUsuario} handleSubmit={this.handleOrdenCompra} list={lista} list1={lista1} 
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verOrdenCompra && <VerOrdenCompra2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleSubmit={this.handleOrdenCompra} 
                args={argsAdd} errors={errorAdd} idLista={idLista} productoI={this.state.productoI} permiteUpdate={permiteUpdate} 
                handleClickidListaI={this.idListaI} list5={this.state.lista5} list={lista} list1={lista1} list2={lista2} 
                fechaFin={fechaFin} fechaHoy={fechaHoy} handleClickidLista={this.idLista} permiteDelete={permiteDelete}/>}
            {addItemOC && <AddItemOC2 styles={this.props.styles} handleLista={this.handleSelDescrProducto} 
                handleSubmit={this.handleItemOC} list={lista} idLista={idLista}
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {showOrdenCompraFin && <AdminOrdenCompraFin2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickidLista={this.idLista} 
                nomUsuarioUA={this.props.nomUsuarioUA} argsBuscCad={argsBuscCad}/>}
            {verOrdenCompraFin && <VerOrdenCompraFin2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleSubmit={this.handleOrdenCompraFin} 
                args={argsAdd} errors={errorAdd} idLista={idLista} preguntaE={this.state.preguntaE} 
                valoracionE={this.state.valoracionE} permiteUpdate={permiteUpdate} 
                list5={this.state.lista5} list6={this.state.lista6} list7={this.state.lista7}
                handleClickidListaE={this.idListaE} list={lista} list1={lista1} 
                fechaHoy={fechaHoy} handleClickidLista={this.idLista} permiteDelete={permiteDelete}/>}
            {addItemEnc && <AddItemEnc2 styles={this.props.styles} handleSubmit={this.handleItemEnc} 
                handleChange={this.handleChange} idLista={idLista} args={argsAdd} errors={errorAdd} />}
            {showEncuesta && <AdminEncuesta2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                list={lista} handleClickidLista={this.idLista}/>}
            {verEncuesta && <VerEncuesta2 styles={this.props.styles} list={lista}  
                args={argsAdd} errors={errorAdd} idLista={idLista} list6={this.state.lista6} permiteUpdate="true"/>}
            {showFacturacion && <AdminFacturacion2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                argsBuscCad={argsBuscCad} handleClickidLista={this.idLista} />}
            {showFacturacionLog && <AdminFacturacionLog2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                argsBuscCad={argsBuscCad} fechaFin={fechaFin} fechaHoy={fechaHoy} />}
            {verFacturacion && <VerFacturacion2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleSubmit={this.handleFacturacion} trmHoy={trmHoy}
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                list={lista} handleClickidListaI={this.idListaI} list5={this.state.lista5}
                fechaHoy={fechaHoy} fechaFin={fechaFin} handleClickidLista={this.idLista} permiteDelete={permiteDelete}/>}
            {/* {showPagosCli && <AdminPagosCli2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                argsBuscCad={argsBuscCad} handleClickidLista={this.idLista} list={lista}/>} */}
            {showPagosCli2 && <AdminPagosCli22 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                argsBuscCad={argsBuscCad} handleClickidLista={this.idLista} list={lista} trmHoy={trmHoy} fechaHoy={fechaHoy}/>}    
            {showRecaudoLog && <AdminRecaudoLog2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                argsBuscCad={argsBuscCad} fechaFin={fechaFin} fechaHoy={fechaHoy} />}
            {showCadena && <AdminCadena2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                // handleClickidLista={this.idLista} handleClickidListaI={this.idListaI}  
                // list5={this.state.lista5} 
                // list={lista} 
                argsBuscCad={argsBuscCad}/>}    
            {showTraslado && <AdminTraslado2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addTraslado} list={lista} 
                handleClickidLista={this.idLista} argsBuscCad={argsBuscCad}/>}
            {addTraslado && <AddTraslado2 styles={this.props.styles} handleLista={this.handleSelDescrEmpresa} 
                handleLista2={this.handleSelDescrContacto} handleSubmit={this.handleTraslado} list={lista} list1={lista1} 
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verTraslado && <VerTraslado2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleSubmit={this.handleTraslado} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                list4={this.state.lista4} addItemT={this.state.addItemT} list={lista} list1={lista1} list2={lista2} list3={lista3}
                permiteDelete={permiteDelete}/>}
            {addItemTras && <AddItemTras2 styles={this.props.styles} handleLista={this.handleSelDescrProducto} 
                handleLista1={this.handleSelDescrUnidad} 
                handleSubmit={this.handleItemTras} tipoC={this.state.tipoC} listItem={listaItem} listUni={lista11} idLista={idLista}
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {showTrasladoFin && <AdminTrasladoFin2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickidLista={this.idLista} 
                nomUsuarioUA={this.props.nomUsuarioUA} argsBuscCad={argsBuscCad}/>}
            {verTrasladoFin && <VerTrasladoFin2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleSubmit={this.handleTrasladoFin} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                list5={this.state.lista5} list6={this.state.lista6} list7={this.state.lista7}
                list={lista} list1={lista1} 
                fechaHoy={fechaHoy} handleClickidLista={this.idLista} permiteDelete={permiteDelete}/>}
            {showInd && <AdminInd2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}/>}
            {showCotizacionPro && <AdminCotizacionPro2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addCotizacionPro} list={lista} handleClickidLista={this.idLista}/>}
            {addCotizacionPro && <AddCotizacionPro2 styles={this.props.styles} 
                handleSubmit={this.handleCotizacionPro} list={lista} 
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verCotizacionPro && <VerCotizacionPro2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleSubmit={this.handleCotizacionPro} 
                args={argsAdd} errors={errorAdd} idLista={idLista} productoI={this.state.productoI} permiteUpdate={permiteUpdate} 
                handleClickidListaI={this.idListaI} list4={this.state.lista4} 
                permiteDelete={permiteDelete}/>}
            {addItemCotiPro && <AddItemCotiPro2 styles={this.props.styles} handleLista={this.handleSelDescrProducto2} 
                handleLista1={this.handleSelOC} handleLista2={this.handleSelCompra} handleSubmit={this.handleItemCotiPro} list={lista} idLista={idLista}
                handleChange={this.handleChange} tipoC='Producto' args={argsAdd} errors={errorAdd} />}
            {showCotizacionProve && <AdminCotizacionProve2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addCotizacionProve} handleClickidLista={this.idLista}/>}
            {addCotizacionProve && <AddCotizacionProve2 styles={this.props.styles} autorizacUA={this.props.autorizacUA} 
                handleSubmit={this.handleCotizacionProve} list={lista} listUni={lista1} list2={lista2} list3={lista3}
                handleLista={this.handleSelDescrProducto3} handleLista1={this.handleSelDescrUnidad}
                handleLista2={this.handleSelDescrProveed} handleLista3={this.handleSelSolicitud} handleLista4={this.handleSelMoneda}
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verCotizacionProve && <VerCotizacionProve2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleSubmit={this.handleCotizacionProve} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}
            {showCotizacionSelecc && <AdminCotizacionSelecc2 autorizacUA={this.props.autorizacUA} 
                styles={this.props.styles} list2={lista}/>}
            {showOrdenCompraPro && <AdminOrdenCompraPro2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                  nomUsuarioUA={this.props.nomUsuarioUA} handleUpdAsDocCoti={this.handleUpdAsDocCoti}
                  handleElimAsDocCoti={this.handleElimAsDocCoti}/>}
            {showRegPago && <AdminRegPago2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                list={lista} handleClickidLista={this.idLista}/>}
            {verRegPago && <VerRegPago2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleSubmit={this.handleRegPago} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                list={lista} handleClickidListaI={this.idListaI} list55={this.state.lista55}
                fechaHoy={fechaHoy} handleClickidLista={this.idLista} permiteDelete={permiteDelete}/>}
          </div>
        </div> 
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allPolitica, {name:'allPolitica'}),
  graphql(queries.mutation.editEmpresa, {name:'editEmpresa'}),
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: {$ne: 'XXXXXXX'}}}]`}}}}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {estado: 'Activo', nombreUsuario: {$ne: 'XXXXXXX'}}}]`}}}}),
  graphql(queries.query.allPerfiles, {name:'allPerfiles', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allPerfilesRtes, {name:'allPerfilesRtes2',
  //   options: (props) => {return {variables: {tipoqry: `[{"$unwind": "$autorizac"},
  //   {$project: {_id: 1, descrPerfil: 1,
  //     codigoAutorizac: '$autorizac.codigoAutorizac'}},   
  //   {$match: {codigoAutorizac: '3545'}}
  //   ]`}}}}),
  graphql(queries.mutation.createPolitica, {name:'createPolitica'}),
  graphql(queries.mutation.editPolitica, {name:'editPolitica'}),
  graphql(queries.mutation.deletePolitica, {name:'deletePolitica'}),
  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionProRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor', estadoCoti: 'Creada', tipo: 'Solicitud'}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionProRtes1',
  options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor', estadoCoti: 'Creada', tipo: 'Solicitud'}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionProRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor', estadoCoti: 'Creada', tipo: 'Cotización'}},
    {"$unwind": "$itemsCoti"},
    {$project: {_id: {$concat: ['$numCoti', '$itemsCoti.descrProducto']}, fechaCreate: 1, numCoti: 1, 
    usuarioCreate: 1, descrProveed: 1, numSolic: 1, tipo: 1, tipoCoti: 1, estadoCoti: 1,
      cantidadCoti: '$itemsCoti.cantidadCoti', descrProducto: '$itemsCoti.descrProducto', descrUnidad: '$itemsCoti.descrUnidad', 
      valorUniCoti: '$itemsCoti.valorUniCoti', porcIVA: '$itemsCoti.porcIVA', 
      porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento'}},   
    {$sort: {numSolic: 1, descrProveed: 1}}
    ]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesTras',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Traslado', estadoCoti: 'Creada'}},
    {$project: {_id: 1, fechaCreate: 1, usuarioCreate: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, nombreContacto: 1, cargoContacto: 1, ciudadContacto: 1,
	    mailContacto: 1, telContacto: 1, lugarEntrega: 1, observacionesAut: 1, usuarioAut: 1, fechaAut: 1, ordenCompraCliente: 1, 
      estadoCoti: 1, observaciones: 1, ciudad: 1, email: 1, telefono: 1}}
    ]`}}}}),
graphql(queries.query.allCotizacionRtes, {name:'allCotizacionProRtes3',
  options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor', estadoCoti: 'Aprobada', tipo: 'Solicitud'}}, {$sort: {fechaCreate: -1}}]`}}}}),

  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoCoti: 'Creada'}}]`}}}}),

  // graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes6',
  //   options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente'}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesFac1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoOC: 'Prefactura'}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesActFact'}),

    graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesAsoc',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoCoti: 'Enviada'}},
    {"$unwind": "$itemsCoti"},
  {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
    descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, ciudadContacto: 1,
    mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, validezOferta: 1, observacionesAut: 1, usuarioAut: 1,
    archivoEnviado: 1, archivoRecibido: 1, totalOC: 1, estadoCoti: 1, observaciones: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, cantidadAprob: '$itemsCoti.cantidadAprob', valorUniAprob: '$itemsCoti.valorUniAprob', 
    porcIVA: '$itemsCoti.porcIVA', porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento'}},
  {$match: {cantidadAprob: {$gt: 0}}},
  {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
    descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, 
    ciudadContacto: 1, mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, 
    validezOferta: 1, observacionesAut: 1, usuarioAut: 1, archivoEnviado: 1, archivoRecibido: 1, totalOC: 1, estadoCoti: 1, observaciones: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, 
    valorItemAsoc: {
      $let: {
          vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
          in: { $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
      }
    },
    valorItemAsocIVA: {
      $let: {
        vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcIVA: {$toInt: '$porcIVA'}, porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
        in: { $multiply: [{ $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}, {$add: [1, {$divide: [ "$$porcIVA", 100 ]} ]}]}
      }
    }
  }},
{$group: {_id: {_id: '$_id', fechaCreate: '$fechaCreate', numCoti: '$numCoti', nombreUsuario: '$nombreUsuario', titulo: '$titulo',
  fechaAut: '$fechaAut', fechaEnvio: '$fechaEnvio', fechaRta: '$fechaRta',
descrPolitica: '$descrPolitica', tipo: '$tipo', ciudadFechaEnvio: '$ciudadFechaEnvio', 
  descrEmpresa: '$descrEmpresa', cedula: '$cedula', nombreContacto: '$nombreContacto', 
  cargoContacto: '$cargoContacto', archivoEnviado: '$archivoEnviado', archivoRecibido: '$archivoRecibido', 
ciudadContacto: '$ciudadContacto', mailContacto: '$mailContacto', telContacto: '$telContacto', 
  referencia: '$referencia', tiempoEntrega: '$tiempoEntrega', lugarEntrega: '$lugarEntrega', 
  formaPago: '$formaPago', totalOC: '$totalOC', 
validezOferta: '$validezOferta', observacionesAut: '$observacionesAut', usuarioAut: '$usuarioAut', 
  estadoCoti: '$estadoCoti', observaciones: '$observaciones', titulo2: '$titulo2', parrafo2: '$parrafo2', titulo3: '$titulo3', parrafo3: '$parrafo3'},
valorTotalAsoc: {$sum: {$toDouble: '$valorItemAsoc'}}, valorTotalAsocIVA: {$sum: {$toDouble: '$valorItemAsocIVA'}}
}},
{$project: {_id: '$_id._id', fechaCreate: "$_id.fechaCreate",
    numCoti: '$_id.numCoti', nombreUsuario: '$_id.nombreUsuario', titulo: "$_id.titulo",
    fechaAut: '$_id.fechaAut', fechaEnvio: '$_id.fechaEnvio',
    fechaRta: '$_id.fechaRta', descrPolitica: '$_id.descrPolitica', tipo: '$_id.tipo', 
      ciudadFechaEnvio: '$_id.ciudadFechaEnvio', descrEmpresa: '$_id.descrEmpresa', cedula: '$_id.cedula', 
      nombreContacto: '$_id.nombreContacto', cargoContacto: '$_id.cargoContacto', 
ciudadContacto: '$_id.ciudadContacto', mailContacto: '$_id.mailContacto', telContacto: '$_id.telContacto', 
      referencia: '$_id.referencia', tiempoEntrega: '$_id.tiempoEntrega', lugarEntrega: '$_id.lugarEntrega', 
      formaPago: '$_id.formaPago', archivoEnviado: '$_id.archivoEnviado', totalOC: '$_id.totalOC', archivoRecibido: '$_id.archivoRecibido', 
validezOferta: '$_id.validezOferta', observacionesaAut: '$_id.observacionesAut', usuarioAut: '$_id.usuarioAut', 
      estadoCoti: '$_id.estadoCoti', observaciones: '$_id.observaciones', titulo2: '$_id.titulo2', parrafo2: '$_id.parrafo2', titulo3: '$_id.titulo3', parrafo3: '$_id.parrafo3', 
      valorUniAprob: {$toDouble: '$valorTotalAsoc'}, cantidadAprob: {$toDouble: '$valorTotalAsocIVA'}
  }}, {$sort: {fechaEnvio: -1}}]`}}}}),

  graphql(queries.mutation.createCotizacion, {name:'createCotizacion'}),
  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),
  graphql(queries.mutation.deleteCotizacion, {name:'deleteCotizacion'}),

  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes00',
  options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoOC: 'Creada'}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes000',
  options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor', estadoOC: 'Cerrada'}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesCot',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoCoti: 'Creada'}}, {$sort: {fechaCreate: -1}},
    {$project: {_id: 1, 
      itemsCoti: {
        $let: {
          vars: {regItem: { $cond: { if: { $isArray: "$itemsCoti" },
                                        then: { $size: "$itemsCoti" },
                                        else: 0} }
          },
          in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                              then: "$itemsCoti",
                              else: [{cantidadAprob: 0, valorUniAprob: 0, porcIVA: 0, porcDcto: 0, porcIncremento: 0}] 
          }}
      }},      
      fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
	    descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, ciudadContacto: 1,
	    mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, validezOferta: 1, observacionesAut: 1, usuarioAut: 1,
      estadoCoti: 1, observaciones: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1}
    },
    {"$unwind": "$itemsCoti"},
    {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
      descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, 
      ciudadContacto: 1, mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, 
      validezOferta: 1, observacionesAut: 1, usuarioAut: 1, estadoCoti: 1, observaciones: 1, titulo2: 1, 
      parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1,
      cantidadAprob: '$itemsCoti.cantidadAprob', porcIncremento: '$itemsCoti.porcIncremento',
      valorUniAprob: '$itemsCoti.valorUniAprob', porcIVA: '$itemsCoti.porcIVA', porcDcto: '$itemsCoti.porcDcto'}},   
    {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
      descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, 
      ciudadContacto: 1, mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, 
      validezOferta: 1, observacionesAut: 1, usuarioAut: 1, estadoCoti: 1, observaciones: 1, titulo2: 1, 
      parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1,
      valorItem: {
        $let: {
            vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
            in: { $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
        }
      },
      valorItemIVA: {
        $let: {
          vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcIVA: {$toInt: '$porcIVA'}, porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
          in: { $multiply: [{ $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}, {$add: [1, {$divide: [ "$$porcIVA", 100 ]} ]}]}
        }
      }
    }},
    {$group: {_id: {_id: '$_id', fechaCreate: '$fechaCreate', numCoti: '$numCoti', nombreUsuario: '$nombreUsuario', titulo: '$titulo',
    fechaAut: '$fechaAut', fechaEnvio: '$fechaEnvio', fechaRta: '$fechaRta',
descrPolitica: '$descrPolitica', tipo: '$tipo', ciudadFechaEnvio: '$ciudadFechaEnvio', 
    descrEmpresa: '$descrEmpresa', cedula: '$cedula', nombreContacto: '$nombreContacto', 
    cargoContacto: '$cargoContacto', 
ciudadContacto: '$ciudadContacto', mailContacto: '$mailContacto', telContacto: '$telContacto', 
    referencia: '$referencia', tiempoEntrega: '$tiempoEntrega', lugarEntrega: '$lugarEntrega', 
    formaPago: '$formaPago', 
validezOferta: '$validezOferta', observacionesAut: '$observacionesAut', usuarioAut: '$usuarioAut', 
    estadoCoti: '$estadoCoti', observaciones: '$observaciones', titulo2: '$titulo2', 
    parrafo2: '$parrafo2', titulo3: '$titulo3', parrafo3: '$parrafo3', ciudad: '$ciudad', email: '$email', telefono: '$telefono'},
  valorTotal: {$sum: {$toDouble: '$valorItem'}}, valorTotalIVA: {$sum: {$toDouble: '$valorItemIVA'}}
}},
{$project: {_id: '$_id._id', fechaCreate: "$_id.fechaCreate",
      numCoti: '$_id.numCoti', nombreUsuario: '$_id.nombreUsuario', titulo: "$_id.titulo",
      fechaAut: '$_id.fechaAut', fechaEnvio: '$_id.fechaEnvio',
      fechaRta: '$_id.fechaRta', descrPolitica: '$_id.descrPolitica', tipo: '$_id.tipo', 
        ciudadFechaEnvio: '$_id.ciudadFechaEnvio', descrEmpresa: '$_id.descrEmpresa', cedula: '$_id.cedula', 
        nombreContacto: '$_id.nombreContacto', cargoContacto: '$_id.cargoContacto', 
ciudadContacto: '$_id.ciudadContacto', mailContacto: '$_id.mailContacto', telContacto: '$_id.telContacto', 
        referencia: '$_id.referencia', tiempoEntrega: '$_id.tiempoEntrega', lugarEntrega: '$_id.lugarEntrega', 
        formaPago: '$_id.formaPago', 
validezOferta: '$_id.validezOferta', observacionesaAut: '$_id.observacionesAut', usuarioAut: '$_id.usuarioAut', 
        estadoCoti: '$_id.estadoCoti', observaciones: '$_id.observaciones', titulo2: '$_id.titulo2', 
        parrafo2: '$_id.parrafo2', titulo3: '$_id.titulo3', parrafo3: '$_id.parrafo3', ciudad: '$_id.ciudad', email: '$_id.email', telefono: '$_id.telefono',
        valorUniAprob: {$toDouble: '$valorTotal'}, cantidadAprob: {$toDouble: '$valorTotalIVA'}
    }}            
    ]`}}}}),

  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes33', 
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoOC: 'Finalizada', emailEncuesta: '${props.usuario}'}}]`}}}}),

  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesFac',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoOC: {$in: ['Prefactura', 'Aprobada']}}},
    {"$unwind": "$itemsFactura"},
      {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, pais: 1,
        estadoOC: 1, valorFact: '$itemsFactura.valorFact', valorPagado: '$itemsFactura.valorPagado', 
        archivoEnviado: 1, archivoRecibido: 1, ordenCompraCliente: 1, estadoOC: 1,
        numAvance: {"$toString": "$itemsFactura.numAvance"}, numFactura: '$itemsFactura.numFactura', archivoFactura: '$itemsFactura.archivoFactura',
        usuarioSolic: '$itemsFactura.usuarioSolic', fechaSolic: '$itemsFactura.fechaSolic', usuarioFact: '$itemsFactura.usuarioFact',
        fechaFact: '$itemsFactura.fechaFact', fechaPago: '$itemsFactura.fechaPago', usuarioPago: '$itemsFactura.usuarioPago'}},
      {$project: {_id: {$concat: ['$numOrdenCompra', '$numAvance']}, numOrdenCompra: 1, numCoti: 1, pais: 1,
      tipo: 1, tipoCoti: 1, descrEmpresa: 1, ordenCompraCliente: 1, estadoOC: 1,
      estadoOC: 1, valorFact: 1, valorPagado: 1, numAvance: 1, numFactura: 1, 
      archivoFactura: 1, archivoEnviado: 1, archivoRecibido: 1,
      usuarioSolic: 1, fechaSolic: 1, usuarioFact: 1, fechaFact: 1, fechaPago: 1, usuarioPago: 1,
      totalOC: {
        $let: {
            vars: {valorFact: {$toInt: '$valorFact'}, valorPagado: {$toInt: '$valorPagado'}},
            in: { $subtract: [ "$$valorFact", "$$valorPagado" ] }
        }
      }
      }},
      {$match: {numFactura: ""}},
      {$sort: {numOrdenCompra: -1, numAvance: 1}}
    ]`}}}}),
  // graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesFacLog',
  //   options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoOC: {$in: ['Prefactura', 'Aprobada', 'Factura', 'Pagada']}}},
  //   {"$unwind": "$itemsFactura"},
  //     {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, numCoti: 1, descrEmpresa: 1, pais: 1, 
  //     archivoEnviado: 1, archivoRecibido: 1, archivoFactura: '$itemsFactura.archivoFactura', 
  //       estadoOC: 1, nombreUsuario: 1, nombreUsuarioOC: 1, ordenCompraCliente: 1, totalOC: 1, fechaRta: 1, 
  //       valorFact: '$itemsFactura.valorFact', valorFactSinIva: '$itemsFactura.valorFactSinIva', valorPagado: '$itemsFactura.valorPagado', 
  //       numAvance: {"$toString": "$itemsFactura.numAvance"}, numFactura: '$itemsFactura.numFactura', 
  //       fechaSolic: '$itemsFactura.fechaSolic', usuarioFact: '$itemsFactura.usuarioFact',
  //       fechaFact: '$itemsFactura.fechaFact'}},
  //     {$project: {_id: {$concat: ['$numOrdenCompra', '$numAvance']}, numOrdenCompra: 1, numCoti: 1, descrEmpresa: 1, pais: 1, 
  //     archivoEnviado: 1, archivoRecibido: 1, archivoFactura: 1, 
  //     estadoOC: 1, nombreUsuario: 1, nombreUsuarioOC: 1, ordenCompraCliente: 1, totalOC: 1, fechaRta: 1, 
  //     valorFact: 1, valorFactSinIva: 1, valorPagado: 1, numAvance: 1, numFactura: 1, fechaSolic: 1, usuarioFact: 1, fechaFact: 1,
  //     consecAvance: {
  //       $let: {
  //           vars: {valorFact: {$toInt: '$valorFact'}, valorPagado: {$toInt: '$valorPagado'}},
  //           in: { $subtract: [ "$$valorFact", "$$valorPagado" ] }
  //       }
  //     }
  //     }},
  //     {$sort: {numOrdenCompra: -1, numAvance: 1}}
  //   ]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesRecLog',
    options: (props) => {return {variables: {tipoqry: `[{$match: {fechaRta: { $gte: new Date('2023-10-01')}, tipoCoti: 'Cliente', estadoOC: {$in: ['Prefactura', 'Aprobada', 'Factura', 'Pagada']}}},
    {"$unwind": "$itemsPagos"},
      {$project: {numOrdenCompra: 1, numCoti: 1, descrEmpresa: 1, pais: 1, monedaCoti: 1, 
        estadoOC: 1, nombreUsuario: 1, nombreUsuarioOC: 1, ordenCompraCliente: 1, fechaRta: 1, valorPago: '$itemsPagos.valorPago', 
        valorAjuste: '$itemsPagos.valorAjuste', valorRetencion: '$itemsPagos.valorRetencion', valorIVA: '$itemsPagos.valorIVA', 
        codiAvance: {"$toString": "$itemsPagos.codiAvance"}, usuarioRegPago: '$itemsPagos.usuarioRegPago',
        fechaRegPago: '$itemsPagos.fechaRegPago', observacionAjuste: '$itemsPagos.observacionAjuste'}},
    {$lookup: {from: 'usuarios', localField: 'usuarioRegPago', foreignField: 'email', as: 'usuario'}},
    {$unwind: '$usuario'},
    {$project: {_id: {$concat: ['$numCoti', '$codiAvance']}, numOrdenCompra: 1, numCoti: 1, descrEmpresa: 1, pais: 1, monedaCoti: 1, 
      estadoOC: 1, nombreUsuario: 1, nombreUsuarioOC: 1, ordenCompraCliente: 1, fechaRta: 1, valorPago: 1, valorIVA: 1, 
      valorAjuste: 1, valorRetencion: 1, codiAAvance: 1, fechaRegPago: 1, observacionAjuste: 1, usuarioRegPago: '$usuario.nombreUsuario'}},
    {$sort: {fechaRegPago: -1}}
    ]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesPagos22',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente'}},
    {"$unwind": "$itemsFactura"},
    {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, pais: 1, 
    archivoEnviado: 1, archivoRecibido: 1, ordenCompraCliente: 1, monedaCoti: 1,
    estadoOC: 1, valorFact: '$itemsFactura.valorFact', 
    valorPagado: {
      $let: {
          vars: {valorPago: '$itemsFactura.valorPagado'},
          in: { $cond: { if: { $eq: [ "$$valorPago", null ] }, then: 0, else: "$$valorPago" } }
      }
    },
    valorFactSinIva: {
      $let: {
          vars: {valorSinIva: '$itemsFactura.valorFactSinIva'},
          in: { $cond: { if: { $eq: [ "$$valorSinIva", null ] }, then: 0, else: "$$valorSinIva" } }
      }
    },
      numAvance: {"$toString": "$itemsFactura.numAvance"}, numFactura: '$itemsFactura.numFactura', 
      venceFact: {$dateFromString: {dateString: "$itemsFactura.venceFact", format: "%Y-%m-%d"}}, archivoFactura: '$itemsFactura.archivoFactura',
      usuarioSolic: '$itemsFactura.usuarioSolic', fechaSolic: '$itemsFactura.fechaSolic', usuarioFact: '$itemsFactura.usuarioFact',
      fechaFact: '$itemsFactura.fechaFact', fechaPago: '$itemsFactura.fechaPago', usuarioPago: '$itemsFactura.usuarioPago'}},
    {$project: {_id: {$concat: ['$numOrdenCompra', '$numAvance']}, numOrdenCompra: 1, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, 
    estadoOC: 1, valorFact: 1, valorFactSinIva: 1, valorPagado: 1, numAvance: 1, numFactura: 1, venceFact: 1, ordenCompraCliente: 1,
    archivoEnviado: 1, archivoRecibido: 1, archivoFactura: 1, monedaCoti: 1, pais: 1, 
    usuarioSolic: 1, fechaSolic: 1, usuarioFact: 1, fechaFact: 1, fechaPago: 1, usuarioPago: 1,
    totalOC: {
      $let: {
          vars: {valorFact: {$toDouble: '$valorFact'}, valorPagado: {$toDouble: '$valorPagado'}},
          in: { $subtract: [ "$$valorFact", "$$valorPagado" ] }
      }
    }
    }},
    {$match: {numFactura: {$ne: ""}, totalOC: {$gt: 0}}}, 
    {$sort: {descrEmpresa: 1, numOrdenCompra: 1, numAvance: 1}}
    ]`}}}}),

    graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes444',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor', tipo: 'Cotización', estadoOC: {$in: ['Cerrada']}}},
    {$project: {_id: 1, 
      itemsCoti: {
        $let: {
          vars: {regItem: { $cond: { if: { $isArray: "$itemsCoti" },
                                        then: { $size: "$itemsCoti" },
                                        else: 0} }
          },
          in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                              then: "$itemsCoti",
                              else: [{cantidadRecibida: 0, valorUniAprob: 0, porcIVA: 0, porcDcto: 0, porcIncremento: 0}] 
          }}
      }},      
      numOrdenCompra: 1, fechaCreate: 1, numSolic: 1, descrProveed: 1, ciudad: 1, 
      numFactura: 1, tipo: 1, archivoFactura: 1,  
      estadoOC: 1, tipoCoti: 1}},
    {"$unwind": "$itemsCoti"},
    {$project: {_id: 1, numOrdenCompra: 1, fechaCreate: 1, numSolic: 1, descrProveed: 1, ciudad: 1, 
      numFactura: 1, tipo: 1, archivoFactura: 1,  
      estadoOC: 1, tipoCoti: 1, cantidadRecibida: '$itemsCoti.cantidadRecibida', valorUniCoti: '$itemsCoti.valorUniCoti', 
      porcIVA: '$itemsCoti.porcIVA', porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento'}},
    {$match: {cantidadRecibida: {$gt: 0}}},
    {$project: {_id: 1, numOrdenCompra: 1, fechaCreate: 1, numSolic: 1, descrProveed: 1, ciudad: 1, 
      numFactura: 1, tipo: 1, archivoFactura: 1,  
      estadoOC: 1, tipoCoti: 1,
      valorItem: {
        $let: {
            vars: {cantidadRecibida: {$toInt: '$cantidadRecibida'}, valorUniCoti: '$valorUniCoti', porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
            in: { $multiply: [ "$$cantidadRecibida", {$multiply: [{$divide: ["$$valorUniCoti", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
        }
      },
      valorItemIVA: {
        $let: {
          vars: {cantidadRecibida: {$toInt: '$cantidadRecibida'}, valorUniCoti: '$valorUniCoti', porcIVA: {$toInt: '$porcIVA'}, porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
          in: { $multiply: [{ $multiply: [ "$$cantidadRecibida", {$multiply: [{$divide: ["$$valorUniCoti", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}, {$add: [1, {$divide: [ "$$porcIVA", 100 ]} ]}]}
        }
      }
    }},
    {$group: {_id: {_id: '$_id', numOrdenCompra: '$numOrdenCompra', fechaCreate: '$fechaCreate', 
      numSolic: '$numSolic', descrProveed: '$descrProveed', 
      ciudad: '$ciudad', tipo: '$tipo', 
	    numFactura: '$numFactura', estadoOC: '$estadoOC'},
      valorTotal: {$sum: {$toDouble: '$valorItem'}}, valorTotalIVA: {$sum: {$toDouble: '$valorItemIVA'}}
    }},
    {$project: {_id: '$_id._id', numOrdenCompra: '$_id.numOrdenCompra', fechaCreate: '$_id.fechaCreate', 
    numSolic: '$_id.numSolic', descrProveed: '$_id.descrProveed', 
    ciudad: '$_id.ciudad', tipo: '$_id.tipo', 
    numFactura: '$_id.numFactura', estadoOC: '$_id.estadoOC',
    valorUniAprob: {$toDouble: '$valorTotal'}, cantidadAprob: {$toDouble: '$valorTotalIVA'}
    }}            
    ]`}}}}),


  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),
  graphql(queries.mutation.editSolicCompra, {name:'editSolicCompra'}),

  // graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: {$ne: 'Externo'}}}]`}}}}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: 'Externo'}}]`}}}}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: 'Comercial', estado: 'Activo'}}]`}}}}),

  graphql(queries.query.allProducto, {name:'allProducto'}),

  graphql(queries.query.allPolitica, {name:'allPolitica'}),
  graphql(queries.query.allProveed, {name:'allProveed'}),
  graphql(queries.query.allMaterial, {name:'allMaterial'}),
  graphql(queries.query.allUnidad, {name:'allUnidad'}),

  graphql(queries.query.allEncuesta, {name:'allEncuesta'}),
  graphql(queries.mutation.createUsuario, {name:'createUsuario'}),

  graphql(queries.mutation.singleUpload, {name:'singleUpload'}),
  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.mutation.encriptar, {name:'encriptar'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(HomeAdmin)
